// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./buy-sell_before_light.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./buy-sell_before.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./buy-sell_before2_light.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./buy-sell_before2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23707a8a%27 stroke-width=%272%27%3E%3Cpath d=%27M9 6l6 6-6 6%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buy-sell-page {
  width: 100%;
  min-height: 100vh;
  background: #14151a;
  color: #ffffff;
  padding: 40px 16px 40px;
  box-sizing: border-box;
}

body.light_theme .buy-sell-page {
  background: #f8f9fa;
  color: #121317;
}

.buy-sell-page__container {
  max-width: 1180px;
  margin: 0 auto;
}

.buy-sell-page__header {
  margin-bottom: 24px;
}

.buy-sell-page__pageTitle {
  margin: 0 0 6px;
  font-size: 32px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #ffffff;
}

body.light_theme .buy-sell-page__pageTitle {
  color: #121317;
}

.buy-sell-page__subtitle {
  margin: 0;
  font-size: 14px;
  color: #848e9c;
  line-height: 1.45;
}

body.light_theme .buy-sell-page__subtitle {
  color: #707a8a;
}

.buy-sell-page__titleHighlight {
  color: #d1aa67;
}

.buy-sell-page__mainGrid {
  display: grid;
  grid-template-columns: 1.15fr 1fr;
  gap: 36px;
  align-items: stretch;
  margin-bottom: 32px;
}

@media (min-width: 992px) {
  .buy-sell-page__card--hot {
    order: 1;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
  }

  .buy-sell-page__card--trade {
    order: 2;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .buy-sell-page__stepper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-bottom: 0;
  }

  .buy-sell-page__step {
    flex: 1 1;
    display: flex;
    align-items: flex-start;
    gap: 18px;
  }

  .buy-sell-page__stepIconWrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-self: stretch;
    height: 100%;
  }

  .buy-sell-page__stepLine {
    flex: 1 1 auto !important;
    height: auto !important;
    min-height: 148px;
  }
}

@media (max-width: 991px) {
  .buy-sell-page__mainGrid {
    grid-template-columns: 1fr;
    display: flex;
    flex-direction: column;
    gap: 32px;
  }

  .buy-sell-page__card--trade {
    order: 1;
  }

  .buy-sell-page__card--hot {
    order: 2;
    padding: 0;
    background: transparent;
    border: none;
    box-shadow: none;
  }

  .buy-sell-page__stepper {
    display: flex;
    flex-direction: column;
    gap: 0px;
  }

  .buy-sell-page__step {
    display: flex;
    align-items: stretch;
    gap: 16px;
  }

  .buy-sell-page__stepIconWrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-self: stretch;
  }

  .buy-sell-page__featureCard {
    padding: 14px 16px;
    margin-top: 8px;
  }
}

.buy-sell-page__card {
  width: 100%;
}

.buy-sell-page__card--hot {
  padding: 0;
  overflow: visible;
  display: flex;
  flex-direction: column;
}

.buy-sell-page__card--hot .buy-sell-page__pageTitle {
  margin: 0 0 10px;
  font-size: 36px;
  font-weight: 600;
  letter-spacing: 0;
  color: #ffffff;
}

body.light_theme .buy-sell-page__card--hot .buy-sell-page__pageTitle {
  color: #121317;
}

.buy-sell-page__card--hot .buy-sell-page__subtitle {
  margin: 0 0 20px;
  font-size: 17px;
  font-weight: 400;
  color: #848e9c;
  line-height: 1.45;
}

body.light_theme .buy-sell-page__card--hot .buy-sell-page__subtitle {
  color: #707a8a;
}

/* Dynamic Asset Badges Bar */
.buy-sell-page__badgeBar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
  padding-bottom: 32px;
  border-bottom: 1px solid #232730;
  /* height: 56px; */
  box-sizing: border-box;
}

body.light_theme .buy-sell-page__badgeBar {
  border-bottom-color: #dfe0e2;
}

.buy-sell-page__badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  background: transparent;
  border: 1px solid #2b3139;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  color: #ebebeb;
}

body.light_theme .buy-sell-page__badge {
  background: #f8f9fa;
  border-color: #dfe0e2;
  color: #262933;
}

.buy-sell-page__badgeIcon {
  font-size: 15px;
  color: #848e9c;
}

/* 3-Step Vertical Stepper */
.buy-sell-page__stepper {
  display: flex;
  flex-direction: column;
  padding-left: 2px;
  margin-top: 24px;
  padding-bottom: 0;
}

.buy-sell-page__step {
  display: flex;
  align-items: flex-start;
  gap: 18px;
}

.buy-sell-page__stepIconWrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.buy-sell-page__stepDiamond {
  width: 32px;
  height: 32px;
  background: #363b47;
  border-radius: 4px;
  transform: rotate(45deg);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  z-index: 2;
}

body.light_theme .buy-sell-page__stepDiamond {
  background: #dfe0e2;
}

.buy-sell-page__stepDiamond span {
  transform: rotate(-45deg);
  font-size: 15px;
  font-weight: 600;
  color: #ffffff;
  line-height: 1;
}

body.light_theme .buy-sell-page__stepDiamond span {
  color: #121317;
}

.buy-sell-page__stepLine {
  width: 0;
  height: 132px;
  border-left: 2px dashed #363b47;
  margin: 6px 0;
}

body.light_theme .buy-sell-page__stepLine {
  border-left-color: #dfe0e2;
}

.buy-sell-page__stepContent {
  flex: 1 1 auto;
  min-width: 0;
  padding-top: 2px;
  padding-bottom: 20px;
}

.buy-sell-page__step:last-child .buy-sell-page__stepContent {
  padding-bottom: 0;
}

.buy-sell-page__stepTitle {
  margin: 0 0 6px;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0;
  color: #ffffff;
}

body.light_theme .buy-sell-page__stepTitle {
  color: #121317;
}

.buy-sell-page__stepDesc {
  margin: 0;
  font-size: 15px;
  line-height: 1.5;
  color: #848e9c;
  width: 100%;
}

/* Trade Card (Right Column) */
.buy-sell-page__card--trade {
  background: #181a20;
  border: 1px solid #2b2f36;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.35);
  padding: 0 0 18px;
}

body.light_theme .buy-sell-page__card--trade {
  background: #ffffff;
  border-color: #dfe0e2;
  box-shadow: 0 8px 24px rgba(15, 18, 24, 0.08);
}

.buysell_mid_sl {
  padding: 24px 24px 10px;
}

.buy-sell-page__tabs {
  display: flex;
  margin-bottom: 0px;
  background: #202329;
  height: 56px;
  overflow: hidden;
  isolation: isolate;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}

body.light_theme .buy-sell-page__tabs {
  background: #f2f3f4;
}

body.light_theme .buy-sell-page__tab {
  background: #f2f3f4;
  color: #a0a3a7;
}

body.light_theme .buy-sell-page__tab--active,
body.light_theme button.buy-sell-page__tab.buy-sell-page__tab--active,
body.light_theme button.buy-sell-page__tab.buybtn_lft.buy-sell-page__tab--active {
  background: #ffffff;
  background-color: #ffffff;
}

.buy-sell-page__tab {
  flex: 1 1;
  border: none;
  background: #202329;
  height: 56px;
  padding: 0 20px;
  font: inherit;
  position: relative;
  font-size: 18px;
  font-weight: 700;
  color: #848e9c;
  border-radius: 0px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

button.buy-sell-page__tab.buybtn_lft {
  border-radius: 0px;
  position: relative;
}

button.buy-sell-page__tab::before {
  position: absolute;
  top: 0;
  bottom: -1px;
  left: -7px;
  content: "";
  width: 42px;
  height: auto;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat left top / 100% 100%;
  pointer-events: none;
  z-index: 2;
}

body.light_theme button.buy-sell-page__tab::before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat left top / 100% 100%;
}

button.buy-sell-page__tab.buybtn_lft::before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat right top / 100% 100%;
  right: -3px;
  left: auto;
  z-index: 2;
}

body.light_theme button.buy-sell-page__tab.buybtn_lft::before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat right top / 100% 100%;
}

button.buy-sell-page__tab.buy-sell-page__tab--active::before {
  display: none;
}

.buy-sell-page__tab--active {
  z-index: 1;
  background: #181a20;
  color: #e45561 !important;
}

body.light_theme .buy-sell-page__tab--active {
  background: #fff;
  color: #e45561 !important;
}

button.buy-sell-page__tab.buybtn_lft.buy-sell-page__tab--active {
  background: #181a20;
}

body.light_theme button.buy-sell-page__tab.buybtn_lft.buy-sell-page__tab--active {
  background: #fff;
}

.buy-sell-page__field {
  margin-bottom: 16px;
  border: 1px solid #2b3139;
  background: transparent;
  padding: 16px 20px;
  border-radius: 16px;
  position: relative;
  transition: border-color 0.2s ease;
}

body.light_theme .buy-sell-page__field {
  background: #f8f9fa;
  border-color: #dfe0e2;
}

.buy-sell-page__field:focus-within {
  border-color: #f0b90b;
}

.buy-sell-page__field--spendFiat {
  z-index: 1;
}

.buy-sell-page__field--spendFiatOpen {
  z-index: 20;
}

.buy-sell-page__field--receivePicker {
  z-index: 1;
}

.buy-sell-page__field--receivePickerOpen {
  z-index: 20;
}

.buy-sell-page__field--sellCrypto {
  z-index: 1;
}

.buy-sell-page__field--sellCryptoOpen {
  z-index: 20;
}

.buy-sell-page__fieldLbl {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #848e9c;
  margin-bottom: 8px;
}

body.light_theme .buy-sell-page__fieldLbl {
  color: #848e9c;
}

.buy-sell-page__fieldRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.buy-sell-page__input {
  flex: 1 1;
  min-width: 0;
  border: none;
  background: transparent;
  font: inherit;
  font-size: 22px;
  font-weight: 700;
  color: #ffffff;
  padding: 0;
}

body.light_theme .buy-sell-page__input {
  color: #121317;
}

.buy-sell-page__field.is-mirrored .buy-sell-page__input {
  opacity: 0.88;
}

.buy-sell-page__input::placeholder {
  color: #646a78;
}

.buy-sell-page__input:focus {
  outline: none;
}

.buy-sell-page__assetPill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  padding: 6px 14px 6px 8px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 700;
}

button.buy-sell-page__assetPill--btn {
  border: 1px solid #2e323d;
  background: #252831;
  color: #ffffff;
  padding: 6px 14px 6px 8px;
  margin: 0;
  border-radius: 20px;
  cursor: pointer;
  transition:
    background 0.2s ease,
    border-color 0.2s ease;
}

body.light_theme button.buy-sell-page__assetPill--btn {
  background: #ffffff;
  border-color: #dfe0e2;
  color: #121317;
}

button.buy-sell-page__assetPill--btn:hover {
  background: #2e323e;
}

body.light_theme button.buy-sell-page__assetPill--btn:hover {
  background: #f2f3f4;
}

button.buy-sell-page__assetPill--btn:focus-visible {
  outline: 2px solid #262933;
  outline-offset: 2px;
  border-radius: 8px;
}

.buy-sell-page__pillIcon {
  width: 22px;
  height: 22px;
  object-fit: contain;
}

.buy-sell-page__cryptoPillIcon {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  object-fit: contain;
  flex-shrink: 0;
  background: #f4faf6;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.06);
}

.buy-sell-page__cryptoPillIcon--lg {
  width: 36px;
  height: 36px;
}

.buy-sell-page__flagInr {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: linear-gradient(180deg,
      #ff9933 0%,
      #ffffff 45%,
      #138808 45%,
      #138808 100%);
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.08);
}

.buy-sell-page__flagInr--lg {
  width: 30px;
  height: 30px;
}

.buy-sell-page__fiatCircle {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.08);
}

.buy-sell-page__fiatCircle--lg {
  width: 30px;
  height: 30px;
}

.buy-sell-page__fiatCircleText {
  font-size: 7px;
  font-weight: 700;
  color: #fff;
  line-height: 1.05;
  letter-spacing: -0.02em;
  text-align: center;
  padding: 0 2px;
}

.buy-sell-page__fiatCircle--lg .buy-sell-page__fiatCircleText {
  font-size: 10px;
}

.buy-sell-page__fiatDropdown {
  position: absolute;
  left: 0px;
  right: 0px;
  top: calc(100% + 4px);
  background: #fff;
  border-radius: 12px;
  box-shadow:
    0 10px 28px rgba(0, 0, 0, 0.12),
    0 0 0 1px rgba(0, 0, 0, 0.06);
  padding: 10px 0 8px;
  max-height: 300px;
  display: flex;
  flex-direction: column;
}

/* Mobile: currency/asset pickers render in a portal (card has overflow:hidden and clips absolute dropdowns) */
.buy-sell-page__currencyPickerOverlay {
  position: fixed;
  inset: 0;
  z-index: 9999999999999999;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  align-items: flex-end;
  justify-content: center;
  padding: 0;
  animation: bsp-fade-in 160ms ease-out both;
}

body.light_theme .buy-sell-page__currencyPickerOverlay {
  background: rgb(255 255 255 / 20%);
}

.buy-sell-page__currencyPickerSheet {
  width: 100%;
  max-height: min(88vh, 780px);
  background: rgb(26 26 26 / 20%);
  border: 1px solid rgb(255 255 255 / 5%);
  border-radius: 18px 18px 0 0;
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  box-shadow: 0 -10px 40px rgba(0, 0, 0, 0.18);
  padding: 8px 0 calc(12px + env(safe-area-inset-bottom, 0px));
  display: flex;
  flex-direction: column;
  min-height: 0;
  animation: bsp-sheet-up 220ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

body.light_theme .buy-sell-page__currencyPickerSheet {
  background: #fff;
}

.buy-sell-page__currencyPickerOverlay .buy-sell-page__fiatDropdown--sheet {
  background: none !important;
  border: none !important;
}

.buy-sell-page__currencyPickerHandle {
  width: 44px;
  height: 5px;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.12);
  margin: 4px auto 10px;
  flex-shrink: 0;
}

@keyframes bsp-fade-in {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes bsp-sheet-up {
  from {
    transform: translateY(18px);
  }

  to {
    transform: translateY(0);
  }
}

@media (prefers-reduced-motion: reduce) {

  .buy-sell-page__currencyPickerOverlay,
  .buy-sell-page__currencyPickerSheet,
  .buy-sell-page__payOverlay,
  .buy-sell-page__payDialog {
    animation: none !important;
  }
}

.buy-sell-page__fiatDropdown--sheet {
  position: relative;
  left: auto;
  right: auto;
  top: auto;
  box-shadow: none;
  max-height: none;
  flex: 1 1 auto;
  min-height: 0;
  padding: 6px 0 4px;
  border-radius: 0;
}

.buy-sell-page__fiatDropdown--sheet .buy-sell-page__fiatList {
  max-height: min(52vh, 520px);
}

.buy-sell-page__fiatSearch {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 12px 8px;
  padding: 10px 12px;
  background: #f1f2f4;
  border-radius: 10px;
}

.buy-sell-page__fiatSearchIcon {
  font-size: 18px;
  color: #8e9299;
  flex-shrink: 0;
}

.buy-sell-page__fiatSearchInput {
  border: none;
  background: transparent;
  flex: 1 1;
  min-width: 0;
  font: inherit;
  font-size: 14px;
  color: #262933;
  outline: none;
}

.buy-sell-page__fiatSearchInput::placeholder {
  color: #a0a3a7;
}

.buy-sell-page__fiatList {
  list-style: none;
  margin: 0;
  padding: 0 8px 4px;
  overflow-y: auto;
  max-height: 232px;
}

.buy-sell-page__fiatOption {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 10px 10px;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 10px;
  text-align: left;
  font: inherit;
  color: inherit;
}

.buy-sell-page__fiatOption:hover {
  background: #f2f3f4;
}

.buy-sell-page__fiatOption:focus-visible {
  outline: 2px solid #262933;
  outline-offset: -2px;
}

.buy-sell-page__fiatOptionMeta {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.buy-sell-page__fiatOptionCode {
  font-size: 15px;
  font-weight: 600;
}

.buy-sell-page__fiatOptionName {
  font-size: 12px;
  font-weight: 500;
  color: #8e9299;
}

.buy-sell-page__fiatEmpty {
  margin: 0;
  padding: 16px 12px;
  font-size: 14px;
  color: #8e9299;
  text-align: center;
  list-style: none;
}

.buy-sell-page__pillCode {
  letter-spacing: 0.02em;
}

.buy-sell-page__pillCaret {
  font-size: 18px;
  color: var(--bsp-muted);
  transition: transform 0.2s ease;
}

.buy-sell-page__pillCaret--open {
  transform: rotate(180deg);
}

.buy-sell-page__paySelect {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 0px;
  border: none;
  /* border-radius: var(--bsp-radius-sm); */
  background: none;
  font: inherit;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  text-align: left;
}

.pay_with_container {
  margin-top: 50px;
}

/* .buy-sell-page__paySelect:hover {
  border-color: #d1d5db;
} */

.buy-sell-page__payIcon {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.buy-sell-page__payLabel {
  flex: 1 1;
}

/* Payment method modal */
.buy-sell-page__payOverlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-tap-highlight-color: transparent;
  z-index: 9999999;
  background-color: rgb(10 10 10 / 20%);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  animation: bsp-fade-in 160ms ease-out both;
}

body.light_theme .buy-sell-page__payOverlay {
  background-color: rgba(255, 255, 255, 0.2);
}

.buy-sell-page__payDialog {
  width: min(720px, 100%);
  max-height: min(86vh, 760px);
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: bsp-pop-in 180ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

@keyframes bsp-pop-in {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.98);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.buy-sell-page__payHead {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px 10px;
}

.buy-sell-page__payTitle {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #f3f3f3;
}

body.light_theme .buy-sell-page__payTitle {
  color: #111827;
}

span.buy-sell-page__payRowCcy {
  color: #c4c4c4;
}

body.light_theme span.buy-sell-page__payRowCcy {
  color: #111827;
}

.buy-sell-page__payClose {
  border: none;
  background: transparent;
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
  color: #9aa0a6;
  padding: 6px 10px;
  border-radius: 10px;
}

/* .buy-sell-page__payClose:hover {
  background: #f3f4f6;
  color: #111827;
} */

.buy-sell-page__payBody {
  padding: 0 24px 10px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

.buy-sell-page__paySection {
  padding: 10px 0 4px;
}

.buy-sell-page__paySectionHead {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  color: #9aa0a6;
  padding: 8px 0 10px;
}

.buy-sell-page__payList {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.buy-sell-page__payRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  padding: 16px 16px;
  border-radius: 14px;
  border: 1px solid #e5e7eb;
  background: #fff;
  cursor: pointer;
  text-align: left;
}

.buy-sell-page__payRow:hover {
  border-color: #cbd5e1;
}

.buy-sell-page__payRow--selected {
  border-color: #111827;
}

.buy-sell-page__payRow--disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.buy-sell-page__payRowLeft {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
  flex: 1 1;
}

.buy-sell-page__payRowIconWrap {
  width: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.buy-sell-page__payRowIcon {
  width: 26px;
  height: 26px;
  object-fit: contain;
}

.buy-sell-page__payRowMeta {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.buy-sell-page__payRowLabel {
  font-size: 15px;
  font-weight: 500;
}

.buy-sell-page__payRowSub {
  font-size: 13px;
  color: #9aa0a6;
  font-weight: 500;
  line-height: 1.35;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 430px;
}

.buy-sell-page__payRowRight {
  font-size: 15px;
  font-weight: 500;
  white-space: nowrap;
}

span.buy-sell-page__paySectionLeft {
  font-size: 16px;
  font-weight: 600;
}

span.buy-sell-page__paySectionRight {
  font-weight: 600;
}

/* .buy-sell-page__payRowCcy {
  font-weight: 800;
} */

.buy-sell-page__payFoot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 20px 20px;
  border-top: 1px solid #eef0f2;
}

.buy-sell-page__payFootAmt {
  font-size: 22px;
  font-weight: 700;
}

.buy-sell-page__payFootHint {
  font-size: 14px;
  color: #9aa0a6;
  font-weight: 700;
  margin-top: 2px;
}

.buy-sell-page__payConfirm {
  padding: 14px 22px;
  border-radius: 999px;
  border: none;
  background: #303236;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
}

.buy-sell-page__payConfirm:hover {
  filter: brightness(1.06);
}

.buy-sell-page__payConfirm:disabled {
  background: #eef0f2;
  color: #b8bdc6;
  cursor: not-allowed;
  filter: none;
}

.buy-sell-page__payClose:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.buy-sell-page__bankDialog {
  width: min(760px, 100%);
}

.buy-sell-page__bankForm {
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding-bottom: 6px;
}

.buy-sell-page__bankLbl {
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #313131;
}

.buy-sell-page__bankInput {
  width: 100%;
  border: none;
  background: #f3f4f6;
  border-radius: 12px;
  padding: 14px 14px;
  font: inherit;
  font-size: 14px;
  font-weight: 500;
  color: #111827;
  outline: none;
  box-sizing: border-box;
}

.buy-sell-page__bankInput::placeholder {
  color: #9aa0a6;
  font-weight: 600;
}

.buy-sell-page__bankSelect {
  width: 100%;
  border: none;
  background: #f3f4f6;
  border-radius: 12px;
  padding: 14px 14px;
  font: inherit;
  font-size: 14px;
  font-weight: 500;
  color: #9aa0a6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

.buy-sell-page__bankSelectText {
  color: #9aa0a6;
}

.buy-sell-page__bankCaret--open {
  transform: rotate(180deg);
  display: inline-block;
}

.buy-sell-page__bankDropdown {
  margin-top: 10px;
  background: #fff;
  border-radius: 12px;
  box-shadow:
    0 10px 28px rgba(0, 0, 0, 0.12),
    0 0 0 1px rgba(0, 0, 0, 0.06);
  padding: 10px 0 8px;
  max-height: 320px;
  display: flex;
  flex-direction: column;
}

.buy-sell-page__bankSearch {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 12px 10px;
  padding: 10px 12px;
  background: #f1f2f4;
  border-radius: 10px;
}

.buy-sell-page__bankSearchIcon {
  font-size: 18px;
  color: #8e9299;
  flex-shrink: 0;
}

.buy-sell-page__bankSearchInput {
  border: none;
  background: transparent;
  flex: 1 1;
  min-width: 0;
  font: inherit;
  font-size: 14px;
  color: #262933;
  outline: none;
}

.buy-sell-page__bankSearchInput::placeholder {
  color: #a0a3a7;
}

.buy-sell-page__bankList {
  list-style: none;
  margin: 0;
  padding: 0 8px 4px;
  overflow-y: auto;
  max-height: 248px;
}

.buy-sell-page__bankOption {
  width: 100%;
  border: none;
  background: transparent;
  text-align: left;
  padding: 10px 12px;
  border-radius: 10px;
  font: inherit;
  font-size: 15px;
  font-weight: 500;
  color: #111827;
  cursor: pointer;
}

.buy-sell-page__bankOption:hover {
  background: #f4f5f7;
}

.buy-sell-page__bankEmpty {
  margin: 0;
  padding: 16px 12px;
  font-size: 14px;
  color: #8e9299;
  text-align: center;
  list-style: none;
}

.buy-sell-page__bankPhoneRow {
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
  border: none;
  border-radius: 12px;
  padding: 10px;
  background: #f3f4f5;
}

.buy-sell-page__bankPhoneCode {
  border: none;
  background: none;
  border-right: 1px solid #e4e4e4;
  /* border-radius: 10px; */
  height: 30px;
  padding: 0 10px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font: inherit;
  font-size: 14px;
  font-weight: 700;
  color: #6a7282;
  cursor: pointer;
  white-space: nowrap;
}

.buy-sell-page__countryFlag {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  line-height: 1;
}

.buy-sell-page__bankPhoneCodeText {
  min-width: 40px;
  text-align: left;
}

.buy-sell-page__bankInput--phone {
  flex: 1 1;
  border: none;
  background: transparent;
  padding: 0;
}

.buy-sell-page__phoneDropdown {
  position: absolute;
  left: 0;
  top: calc(100% + 8px);
  width: min(520px, calc(100vw - 64px));
  background: #fff;
  border-radius: 12px;
  box-shadow:
    0 10px 28px rgba(0, 0, 0, 0.12),
    0 0 0 1px rgba(0, 0, 0, 0.06);
  padding: 10px 0 8px;
  z-index: 5;
}

.buy-sell-page__phoneOption {
  width: 100%;
  border: none;
  background: transparent;
  text-align: left;
  padding: 12px 12px;
  border-radius: 10px;
  font: inherit;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
}

.buy-sell-page__phoneOption:hover {
  background: #f4f5f7;
}

.buy-sell-page__phoneOptionMeta {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.buy-sell-page__phoneOptionCode {
  font-size: 15px;
  font-weight: 800;
  color: #111827;
}

.buy-sell-page__phoneOptionName {
  font-size: 12px;
  font-weight: 600;
  color: #8e9299;
}

.buy-sell-page__estimate {
  margin: 36px 0 18px;
  font-size: 14px;
  color: #84888c;
  font-weight: 700;
}

/* Highlight only the rate line “1 USDT = … INR” */
.buy-sell-page__estimateRate {
  color: #f1f1f1;
}

body.light_theme .buy-sell-page__estimateRate {
  color: #000;
}

.buy-sell-page__estimateRate--sell {
  color: var(--bsp-text);
  font-weight: 700;
}

.buy-sell-page__cta {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 52px;
  padding: 0 20px;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  color: #ebebeb;
  background: #2b2f36;
  border-radius: 14px;
  text-decoration: none;
  border: none;
  cursor: pointer;
  box-sizing: border-box;
  transition: all 0.2s ease;
}

.buy-sell-page__cta:not(:disabled) {
  background: #d1aa67;
  color: #ffffff;
}

.buy-sell-page__cta:not(:disabled):hover {
  background: #c59f5e;
  color: #ffffff;
}

.buy-sell-page__cta:disabled {
  background: #2b2f36;
  color: #848e9c;
  cursor: not-allowed;
  filter: none;
}

/* How to buy */
.buy-sell-page__how {
  margin: 100px 0px;
}

.buy-sell-page__sectionTitle {
  margin: 0 0 28px;
  font-size: 38px;
  font-weight: 700;
}

.buy-sell-page__howRow {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px 4px;
  padding-top: 24px;
}

.buy-sell-page__howStep {
  flex: 1 1 140px;
  max-width: 220px;
  text-align: center;
  padding: 12px 8px;
}

.buy-sell-page__howIconWrap {
  width: 110px;
  /* height: 56px; */
  margin: 0 auto 10px;
  /* border-radius: 14px; */
  /* background: #f3f4f6; */
  display: flex;
  align-items: center;
  justify-content: center;
}

.buy-sell-page__howIcon {
  font-size: 26px;
  color: var(--bsp-text);
}

.buy-sell-page__howStepTitle {
  display: block;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.35;
  margin-bottom: 6px;
}

.buy-sell-page__howStepDesc {
  display: block;
  font-size: 12px;
  color: var(--bsp-muted);
  line-height: 1.45;
}

.buy-sell-page__howArrow {
  align-self: center;
  width: 20px;
  height: 20px;
  margin: 0 4px;
  flex-shrink: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) center / contain no-repeat;
  opacity: 0.7;
}

@media (max-width: 767px) {
  .buy-sell-page__howArrow {
    display: none;
  }
}

/* Quick steps + visual */
.buy-sell-page__quick {
  display: grid;
  grid-template-columns: 1fr 1.5fr;
  gap: 32px;
  align-items: center;
  padding: 40px 0px;
}

@media (max-width: 991px) {}

.buy-sell-page__quickVisual {
  display: flex;
  max-width: 430px;
  justify-content: center;
  align-items: center;
}

.buy-sell-page__quickImg {
  max-width: 100%;
  width: min(360px, 100%);
  height: auto;
  object-fit: contain;
}

.buy-sell-page__quickTitle {
  margin: 0 0 22px;
  font-size: 38px;
  font-weight: 700;
  line-height: 1.25;
}

.buy-sell-page__quickList {
  list-style: none;
  margin: 0;
  display: flex;
  position: relative;
  padding: 0;
  flex-direction: column;
  gap: 40px;
  margin-top: 40px;
}

.buy-sell-page__quickList:before {
  content: "";
  position: absolute;
  top: 0;
  left: 11px;
  width: 1px;
  height: 88%;
  background: #232326;
}

body.light_theme .buy-sell-page__quickList:before {
  background: #101828;
}

.buy-sell-page__quickItem {
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
}

.buy-sell-page__quickItem:last-child {
  margin-bottom: 0;
}

@media (max-width: 991px) {
  .buy-sell-page__quickItem {
    text-align: left;
  }
}

.buy-sell-page__quickNum {
  flex-shrink: 0;
  width: 24px;
  position: relative;
  height: 24px;
  border-radius: 50%;
  background: #ffffff12;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

body.light_theme .buy-sell-page__quickNum {
  background: #101828;
}

.buy-sell-page__quickItemTitle {
  display: block;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 6px;
}

.buy-sell-page__quickItemText {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.55;
  color: #84888c;
}



body:not(.light_theme) .buy-sell-page__historyTable,
body:not(.light_theme) .buy-sell-page__historyChip,
body:not(.light_theme) .buy-sell-page__historyRow,
body:not(.light_theme) .buy-sell-page__historyMoreBtn {
  border-color: #2b3139;
}

/* Redesign styles for Subtitle, Feature Sub-Cards, Hints Grid, Quote Summary & Footer Note */
.buy-sell-page__subtitle {
  margin: -10px 0 16px;
  font-size: 14px;
  line-height: 1.45;
  color: #848e9c;
  font-weight: 500;
}

body.light_theme .buy-sell-page__subtitle {
  color: #707a8a;
}

.buy-sell-page__featureCard {

  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 15px;
  width: 100%;
  box-sizing: border-box;
  background: rgb(255 255 255 / 5%);
  /* border: 1px solid #2b3139; */
  border-radius: 10px;
  margin-top: 10px;
  /* box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2); */
  transition: border-color 0.2s ease, transform 0.2s ease;
}

.buy-sell-page__featureCard:hover {
  border-color: #3b404e;
  transform: translateY(-1px);
}

body.light_theme .buy-sell-page__featureCard {
  background: #efefef;
  border-color: #dfe0e2;
}

body.light_theme .buy-sell-page__featureCard:hover {
  border-color: #dfe0e2;
}

.buy-sell-page__featureIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  font-size: 16px;
  flex-shrink: 0;
}

.buy-sell-page__featureIcon--gold {
  background: rgba(240, 185, 11, 0.15);
  color: #f0b90b;
}

.buy-sell-page__featureIcon--blue {
  background: rgba(30, 144, 255, 0.15);
  color: #3b82f6;
}

.buy-sell-page__featureIcon--green {
  background: rgba(1, 188, 141, 0.15);
  color: #01bc8d;
}

.buy-sell-page__featureMeta {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.buy-sell-page__featureTitle {
  font-size: 16px;
  font-weight: 400;
  color: #ffffffe5;
  display: flex;
  align-items: center;
  gap: 6px;
}

body.light_theme .buy-sell-page__featureTitle {
  color: #121317;
}

.buy-sell-page__featureDesc {
  margin: 0;
  font-size: 14px;
  color: #848e9c;
  line-height: 1.4;
}

.buy-sell-page__liveBadgeTag {
  display: inline-flex;
  align-items: center;
  padding: 1px 5px;
  background: rgba(1, 188, 141, 0.15);
  border: 1px solid rgba(1, 188, 141, 0.3);
  color: #01bc8d;
  font-size: 9.5px;
  font-weight: 700;
  border-radius: 4px;
  letter-spacing: 0.04em;
  margin-left: 4px;
  vertical-align: middle;
}

.buy-sell-page__hintsGrid {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
  margin: 10px 0 12px;
  padding: 10px 14px;
  background: transparent;
  border: 1px solid #2b3139;
  border-radius: 12px;
}

body.light_theme .buy-sell-page__hintsGrid {
  background: #f8f9fa;
  border-color: #dfe0e2;
}

.buy-sell-page__hintsCol {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.buy-sell-page__hintsCol--right {
  align-items: flex-end;
  text-align: right;
}

.buy-sell-page__hintIcon {
  font-size: 13px;
  color: #848e9c;
  vertical-align: -1px;
}

.buy-sell-page__liveStatus {
  margin: 0;
  font-size: 11.5px;
  color: #848e9c;
  display: flex;
  align-items: center;
}

.buy-sell-page__liveDot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #01bc8d;
  box-shadow: 0 0 6px #01bc8d;
  display: inline-block;
  margin-right: 5px;
  animation: bsp-dot-pulse 2s infinite;
}

@keyframes bsp-dot-pulse {
  0% {
    opacity: 1;
    transform: scale(1);
  }

  50% {
    opacity: 0.4;
    transform: scale(0.85);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}

.buy-sell-page__liveTxt {
  color: #01bc8d;
  font-weight: 700;
}

.buy-sell-page__quoteTimer {
  margin: 0;
  font-size: 11.5px;
  color: #848e9c;
  display: flex;
  align-items: center;
  gap: 4px;
}

.buy-sell-page__refreshBtn {
  cursor: pointer;
  color: #f0b90b;
  transition: transform 0.3s ease;
}

.buy-sell-page__refreshBtn:hover {
  transform: rotate(180deg);
}

.buy-sell-page__autoRefreshText {
  font-size: 10.5px;
  color: #5e6673;
}

.buy-sell-page__quoteSummaryTitle {
  font-size: 13px;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 2px;
}

body.light_theme .buy-sell-page__quoteSummaryTitle {
  color: #121317;
}

.buy-sell-page__quoteRow {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12.5px;
}

.buy-sell-page__quoteRow span {
  color: #848e9c;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
}

.buy-sell-page__infoIcon {
  font-size: 13px;
  color: #5e6673;
  cursor: help;
}

.buy-sell-page__quoteDivider {
  height: 0;
  border-top: 1px dashed #2b2f36;
  margin: 3px 0;
}

body.light_theme .buy-sell-page__quoteDivider {
  border-top-color: #dfe0e2;
}

.buy-sell-page__greenVal {
  color: #01bc8d !important;
  font-weight: 700 !important;
}

.buy-sell-page__quoteNotice {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 2px;
  padding-top: 6px;
  border-top: 1px solid #1e2026;
  font-size: 11.5px;
  color: #848e9c;
}

body.light_theme .buy-sell-page__quoteNotice {
  border-top-color: #eef0f2;
}

.buy-sell-page__shieldIcon {
  color: #01bc8d;
  font-size: 13px;
}

.buy-sell-page__quoteRow strong {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  flex-wrap: wrap;
}

body.light_theme .buy-sell-page__cta:disabled {
  background: #eaecef;
  color: #a0a3a7;
}

.buy-sell-page__footerGuarantee {
  margin: 10px 0 0;
  text-align: center;
  font-size: 11.5px;
  color: #848e9c;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.buy-sell-page__footerGuarantee i {
  color: #01bc8d;
  font-size: 13px;
}

@media (max-width: 1440px) {
  .buy-sell-page__pageTitle {
    font-size: 36px;
  }

  .buy-sell-page__sectionTitle {
    font-size: 32px;
  }

  .buy-sell-page__quickTitle {
    font-size: 32px;
  }
}

@media (max-width: 1366px) {
  .buy-sell-page__mainGrid {
    gap: 50px;
  }
}

@media (max-width: 1200px) {

  .buy-sell-page__card--hot .buy-sell-page__pageTitle {
    font-size: 32px;
  }

  .buy-sell-page__tab {
    padding: 13px 16px;
    font-size: 18px;
  }

  .buy-sell-page__how {
    margin: 60px 0px;
  }

  .buy-sell-page__sectionTitle {
    font-size: 28px;
  }

  .buy-sell-page__cta {
    padding: 12px 20px;
    font-size: 14px;
  }

  .buy-sell-page__quickTitle {
    font-size: 28px;
  }

  .buy-sell-page__howStepTitle {
    font-size: 18px;
  }

  button.buy-sell-page__tab::before {
    top: 0px;
  }
}

@media (max-width: 991px) {
  .buy-sell-page {
    padding: 55px 24px 64px;
  }

  .buy-sell-page__card--hot .buy-sell-page__pageTitle {
    font-size: 24px;
  }

  .buy-sell-page__card--hot .buy-sell-page__subtitle {
    font-size: 15px;
  }

  .buy-sell-page__sectionTitle {
    font-size: 22px;
  }

  .buy-sell-page__quickTitle {
    font-size: 22px;
    text-align: left;
  }

  .convert-page__sectionTitle {
    font-size: 24px;
  }
}

@media (max-width: 767px) {

  .buy-sell-page {
    padding: 30px 20px 30px;
  }

  .buy-sell-page__cta {
    padding: 10px 20px;
    font-size: 13px;
    height: auto;
    border-radius: 8px;
  }

  .buy-sell-page__card--hot .buy-sell-page__pageTitle {
    font-size: 22px;
  }

  .buy-sell-page__stepTitle {
    font-size: 17px;
  }

  .buy-sell-page__stepDesc {
    font-size: 13px;
  }

  .buy-sell-page__featureTitle {
    font-size: 14px;
  }

  .buy-sell-page__featureDesc {
    font-size: 12px;
  }

  .buy-sell-page__badgeBar {
    margin-bottom: 5px;
    padding-bottom: 24px;
  }

  .buy-sell-page__stepDiamond span {
    font-size: 13px;
  }

  .df-deposit-history-section .container {
    padding: 0px;
  }


  .buy-sell-page__pageTitle {
    font-size: 22px;
    margin-bottom: 15px;
  }

  .buy-sell-page__mainGrid {
    flex-direction: column;
    display: flex;
  }

  .buy-sell-page__container .mobile_view {
    display: block;
    font-size: 22px;
    padding: 0px 0px 5px;
  }

  .buysell_mid_sl {
    padding: 20px 18px 10px;
  }

  .buy-sell-page__payOverlay {
    align-items: end;
  }

  .buy-sell-page__payDialog {
    border-radius: 18px 18px 0px 0px;
  }

  .buy-sell-page__field {
    padding: 14px;
  }

  .pay_with_container {
    margin-top: 0px;
  }

  .buy-sell-page__input {
    font-size: 15px;
  }

  .buy-sell-page__fieldLbl {
    font-size: 13px;
  }

  .buy-sell-page__mainGrid {
    gap: 30px;
  }

  .buy-sell-page__paySelect {
    font-size: 15px;
  }

  .buy-sell-page__hotChart {
    display: none;
  }

  .buy-sell-page__how {
    margin: 30px 0px;
  }

  .buy-sell-page__sectionTitle {
    font-size: 20px;
    margin-bottom: 15px;
  }

  .buy-sell-page__howStepTitle {
    font-size: 15px;
  }

  .buy-sell-page__howIconWrap {
    width: 60px;
  }

  .buy-sell-page__quickVisual {
    display: none;
  }

  .buy-sell-page__quickCopy {
    width: 100%;
  }

  .buy-sell-page__quick {
    grid-template-columns: 1fr;
    padding: 20px 0px;
  }

  .buy-sell-page__quickTitle {
    font-size: 20px;
  }

  .convert-page__assetsSection {
    padding: 30px 20px 30px;
  }

  .buy-sell-page .convert-page__assetsSection {
    padding: 30px 0px 30px;
  }

  .convert-page__sectionTitle {
    font-size: 20px;
  }

  .buy-sell-page__payConfirm {
    padding: 12px 40px;
  }
}

@media (max-width: 580px) {
  .buy-sell-page__quickList:before {
    height: 84%;
  }
}

/* fix kero - Dark theme support for Buy Crypto page */
html[data-theme="dark"] .buy-sell-page,
body:not(.light_theme) .buy-sell-page {
  background: #181a20;
  color: #ffffff;
}

html[data-theme="dark"] .buy-sell-page__pageTitle,
html[data-theme="dark"] .buy-sell-page__hotTitle,
html[data-theme="dark"] .buy-sell-page__hotPrice,
html[data-theme="dark"] .buy-sell-page__sectionTitle,
html[data-theme="dark"] .buy-sell-page__quickTitle,
html[data-theme="dark"] .buy-sell-page__howStepTitle,
html[data-theme="dark"] .buy-sell-page__input,
html[data-theme="dark"] .buy-sell-page__selector,
html[data-theme="dark"] .buy-sell-page__paySelect,
html[data-theme="dark"] .buy-sell-page__payName,
html[data-theme="dark"] .buy-sell-page__payDialogTitle,
html[data-theme="dark"] .convert-page__assetName,
html[data-theme="dark"] .buy-sell-page__hotPair,
html[data-theme="dark"] .buy-sell-page__quickInfo,
html[data-theme="dark"] .buy-sell-page__quickList,
html[data-theme="dark"] .buy-sell-page__promoText,
body:not(.light_theme) .buy-sell-page__pageTitle,
body:not(.light_theme) .buy-sell-page__hotTitle,
body:not(.light_theme) .buy-sell-page__hotPrice,
body:not(.light_theme) .buy-sell-page__sectionTitle,
body:not(.light_theme) .buy-sell-page__quickTitle,
body:not(.light_theme) .buy-sell-page__howStepTitle,
body:not(.light_theme) .buy-sell-page__input,
body:not(.light_theme) .buy-sell-page__selector,
body:not(.light_theme) .buy-sell-page__paySelect,
body:not(.light_theme) .buy-sell-page__payName,
body:not(.light_theme) .buy-sell-page__payDialogTitle,
body:not(.light_theme) .convert-page__assetName,
body:not(.light_theme) .buy-sell-page__hotPair,
body:not(.light_theme) .buy-sell-page__quickInfo,
body:not(.light_theme) .buy-sell-page__quickList,
body:not(.light_theme) .buy-sell-page__promoText {
  color: #ffffff;
}

html[data-theme="dark"] .buy-sell-page__howStepDesc,
html[data-theme="dark"] .buy-sell-page__quickDesc,
html[data-theme="dark"] .convert-page__assetSymbol,
html[data-theme="dark"] .buy-sell-page__payEstimate,
html[data-theme="dark"] .buy-sell-page__tab,
body:not(.light_theme) .buy-sell-page__howStepDesc,
body:not(.light_theme) .buy-sell-page__quickDesc,
body:not(.light_theme) .convert-page__assetSymbol,
body:not(.light_theme) .buy-sell-page__payEstimate,
html[data-theme="dark"] .buy-sell-page__tab,
body:not(.light_theme) .buy-sell-page__tab {
  color: #a0aab5;
  background: #202329;
}

html[data-theme="dark"] .buy-sell-page__tabWrap,
body:not(.light_theme) .buy-sell-page__tabWrap {
  background: #2b3139;
}

html[data-theme="dark"] .buy-sell-page__tab--active,
body:not(.light_theme) .buy-sell-page__tab--active {
  background: #181a20;
}

html[data-theme="dark"] .buy-sell-page__card--buySell,
html[data-theme="dark"] .buy-sell-page__quickInfo,
html[data-theme="dark"] .buy-sell-page__hotTableWrap,
html[data-theme="dark"] .buy-sell-page__promoBanner,
html[data-theme="dark"] .buy-sell-page__card--trade,
body:not(.light_theme) .buy-sell-page__card--buySell,
body:not(.light_theme) .buy-sell-page__quickInfo,
body:not(.light_theme) .buy-sell-page__hotTableWrap,
body:not(.light_theme) .buy-sell-page__promoBanner,
body:not(.light_theme) .buy-sell-page__card--trade {
  background: #181a20;
  border-color: #2b3139;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
}

html[data-theme="dark"] .buy-sell-page__payDialog,
body:not(.light_theme) .buy-sell-page__payDialog {
  background: #181a20a3;
  border-color: #2b3139;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
}

html[data-theme="dark"] .buy-sell-page__field,
html[data-theme="dark"] .buy-sell-page__quoteMeta,
html[data-theme="dark"] .buy-sell-page__paySelect,
body:not(.light_theme) .buy-sell-page__field,
body:not(.light_theme) .buy-sell-page__quoteMeta,
body:not(.light_theme) .buy-sell-page__paySelect {
  background: transparent;
  border-color: #2b3139;
}

html[data-theme="dark"] .buy-sell-page__field:focus-within,
body:not(.light_theme) .buy-sell-page__field:focus-within {
  border-color: #d3b06c;
}

html[data-theme="dark"] .buy-sell-page__payOption:hover,
body:not(.light_theme) .buy-sell-page__payOption:hover {
  background: #2b3139;
}

html[data-theme="dark"] .buy-sell-page__hotTable tr,
body:not(.light_theme) .buy-sell-page__hotTable tr {
  border-bottom: 1px solid #2b3139;
}

html[data-theme="dark"] .buy-sell-page__hotTable tr:last-child,
body:not(.light_theme) .buy-sell-page__hotTable tr:last-child {
  border-bottom: none;
}

html[data-theme="dark"] .buy-sell-page__fiatDropdown,
html[data-theme="dark"] .buy-sell-page__bankDropdown,
html[data-theme="dark"] .buy-sell-page__payRow,
body:not(.light_theme) .buy-sell-page__fiatDropdown,
body:not(.light_theme) .buy-sell-page__bankDropdown,
body:not(.light_theme) .buy-sell-page__payRow {
  background: #181a20;
  border-color: #2b3139;
}

html[data-theme="dark"] .buy-sell-page__fiatSearch,
html[data-theme="dark"] .buy-sell-page__bankSearch,
body:not(.light_theme) .buy-sell-page__fiatSearch,
body:not(.light_theme) .buy-sell-page__bankSearch {
  background: #0d1219;
}

html[data-theme="dark"] .buy-sell-page__fiatSearchInput,
html[data-theme="dark"] .buy-sell-page__bankSearchInput,
html[data-theme="dark"] .buy-sell-page__payRowLabel,
html[data-theme="dark"] .buy-sell-page__payRowPrice,
html[data-theme="dark"] .buy-sell-page__payFootAmt,
html[data-theme="dark"] .buy-sell-page__fiatOptionCode,
html[data-theme="dark"] .buy-sell-page__bankOption,
html[data-theme="dark"] .buy-sell-page__fiatEmpty,
html[data-theme="dark"] .buy-sell-page__bankEmpty,
body:not(.light_theme) .buy-sell-page__fiatSearchInput,
body:not(.light_theme) .buy-sell-page__bankSearchInput,
body:not(.light_theme) .buy-sell-page__payRowLabel,
body:not(.light_theme) .buy-sell-page__payRowPrice,
body:not(.light_theme) .buy-sell-page__payFootAmt,
body:not(.light_theme) .buy-sell-page__fiatOptionCode,
body:not(.light_theme) .buy-sell-page__bankOption,
body:not(.light_theme) .buy-sell-page__fiatEmpty,
body:not(.light_theme) .buy-sell-page__bankEmpty {
  color: #ffffff;
}

html[data-theme="dark"] .buy-sell-page__paySectionLeft,
html[data-theme="dark"] .buy-sell-page__paySectionRight,
body:not(.light_theme) .buy-sell-page__paySectionLeft,
body:not(.light_theme) .buy-sell-page__paySectionRight {
  color: #a0aab5;
}

html[data-theme="dark"] .buy-sell-page__fiatOption:hover,
html[data-theme="dark"] .buy-sell-page__bankOption:hover,
body:not(.light_theme) .buy-sell-page__fiatOption:hover,
body:not(.light_theme) .buy-sell-page__bankOption:hover {
  background: #2b3139;
}

html[data-theme="dark"] .buy-sell-page__payRow:hover,
html[data-theme="dark"] .buy-sell-page__payRow--selected,
body:not(.light_theme) .buy-sell-page__payRow:hover,
body:not(.light_theme) .buy-sell-page__payRow--selected {
  border-color: #d3b06c;
}

html[data-theme="dark"] .buy-sell-page__payFoot,
body:not(.light_theme) .buy-sell-page__payFoot {
  border-top-color: #2b3139;
}

body.light_theme .buy-sell-page__payFoot {
  border-top-color: #eaecef;
}

.buy-sell-page__infoPanel {
  padding: 18px 24px;
  border: 1px solid #dfe0e2;
  border-radius: 16px;
}

.buy-sell-page__infoList {
  margin: 12px 0 0;
  padding-left: 18px;
  color: #707a8a;
  font-size: 14px;
  line-height: 1.55;
}

.buy-sell-page__infoList li+li {
  margin-top: 8px;
}

.buy-sell-page__hints {
  display: grid;
  gap: 4px;
  margin: 0 0 12px;
  min-height: 2.8em;
}

.buy-sell-page__balanceHint,
.buy-sell-page__limitHint {
  margin: 0;
  font-size: 13px;
  color: #848e9c;
  min-height: 1.2em;
  line-height: 1.35;
}

.buy-sell-page__balanceHint--placeholder,
.buy-sell-page__limitHint--placeholder {
  opacity: 0.72;
}

.buy-sell-page__balanceHint--error {
  color: #e45561;
  font-weight: 600;
}

/* Fixed quote breakdown — dark outlined sub-card */
.buy-sell-page__quoteMeta {
  display: grid;
  grid-template-rows: repeat(5, minmax(22px, auto)) auto;
  gap: 10px;
  margin: 0 0 20px;
  padding: 16px 20px;
  border: 1px solid #2b3139;
  border-radius: 16px;
  min-height: 180px;
  background: transparent;
  box-sizing: border-box;
  transition:
    border-color 160ms ease,
    background-color 160ms ease;
}

body.light_theme .buy-sell-page__quoteMeta {
  background: #f8f9fa;
  border-color: #dfe0e2;
}

.buy-sell-page__quoteMeta>div {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 12px;
  font-size: 13.5px;
  min-height: 22px;
}

.buy-sell-page__quoteMeta span {
  color: #848e9c;
  font-weight: 500;
  flex-shrink: 0;
}

.buy-sell-page__quoteMeta strong {
  font-weight: 600;
  color: #ffffff;
  text-align: right;
  word-break: break-word;
}

body.light_theme .buy-sell-page__quoteMeta strong {
  color: #121317;
}

.buy-sell-page__quoteMeta.is-empty strong {
  font-weight: 500;
  color: #848e9c;
}

.buy-sell-page__quoteMeta.is-loading strong {
  animation: bsp-quote-pulse 1.1s ease-in-out infinite;
}

@keyframes bsp-quote-pulse {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.45;
  }
}

.buy-sell-page__countdown {
  margin: 8px 0 0;
  padding-top: 10px;
  border-top: 1px solid #232730;
  font-size: 13px;
  font-weight: 600;
  color: #f0b90b;
  text-align: center;
  min-height: 1.25em;
}

body.light_theme .buy-sell-page__countdown {
  border-top-color: #dfe0e2;
}

.buy-sell-page__countdown.is-refreshing {
  color: #e45561;
}

.buy-sell-page__quoteError {
  margin: 0 0 12px;
  font-size: 13px;
  color: #e45561;
}

.buy-sell-page__quoteList {
  display: grid;
  gap: 12px;
  margin: 0;
}

.buy-sell-page__quoteList dt {
  margin: 0 0 4px;
  font-size: 12px;
  color: #848e9c;
}

.buy-sell-page__quoteList dd {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #ffffff;
}

body.light_theme .buy-sell-page__quoteList dd {
  color: #121317;
}

.buy-sell-page__quoteHint {
  margin: 16px 0 0;
  font-size: 13.3px;
  line-height: 1.45;
  color: #848e9c;
}

.buy-sell-page__history {
  margin: 8px 0 48px;
}

.buy-sell-page__historyTop {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

.buy-sell-page__historyFilters {
  display: flex;
  gap: 8px;
}

.buy-sell-page__historyChip {
  border: 1px solid #dfe0e2;
  background: transparent;
  color: inherit;
  border-radius: 999px;
  padding: 6px 14px;
  font-size: 13px;
  cursor: pointer;
}

.buy-sell-page__historyChip.is-active {
  background: #303236;
  border-color: #303236;
  color: #fff;
}

.buy-sell-page__historyStatus,
.buy-sell-page__historyEmpty {
  margin: 0;
  padding: 16px 4px;
  font-size: 14px;
  color: #848e9c;
}

.buy-sell-page__historyTable {
  border: 1px solid #dfe0e2;
  border-radius: 16px;
  overflow: hidden;
}

.buy-sell-page__historyHead,
.buy-sell-page__historyRow {
  display: grid;
  grid-template-columns: 1.3fr 0.7fr 1.1fr 1.1fr 0.9fr 0.85fr 0.75fr;
  gap: 8px;
  padding: 12px 16px;
  align-items: center;
}

.buy-sell-page__historyHead {
  font-size: 13px;
  color: #848e9c;
}

.buy-sell-page__historyRow {
  border-top: 1px solid #dfe0e2;
  font-size: 13px;
}

.buy-sell-page__historyCell {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.buy-sell-page__historyRepeat {
  color: #c9a227;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
}

.buy-sell-page__historyRepeat:hover {
  text-decoration: underline;
}

.buy-sell-page__historyReview {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 32px;
  padding: 4px 14px;
  border-radius: 999px;
  border: 1px solid #d1aa67;
  background: transparent;
  color: #d1aa67;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.buy-sell-page__historyReview:hover {
  background: rgba(209, 170, 103, 0.12);
}

.buy-sell-page__historyCopy {
  margin-left: 8px;
  border: 0;
  background: transparent;
  color: #d1aa67;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.buy-sell-page__historyBadge {
  display: inline-flex;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
}

.buy-sell-page__historyBadge.is-success {
  color: #01bc8d;
  background: rgba(1, 188, 141, 0.12);
}

.buy-sell-page__historyBadge.is-pending {
  color: #c9a227;
  background: rgba(201, 162, 39, 0.12);
}

.buy-sell-page__historyBadge.is-danger {
  color: #e45561;
  background: rgba(228, 85, 97, 0.12);
}

.buy-sell-page__historyBadge.is-neutral {
  color: #848e9c;
  background: rgba(132, 142, 156, 0.12);
}

.buy-sell-page__historyMore {
  display: flex;
  justify-content: center;
  padding: 16px 0 0;
}

.buy-sell-page__historyMoreBtn {
  border: 1px solid #dfe0e2;
  background: transparent;
  color: inherit;
  border-radius: 999px;
  padding: 8px 18px;
  font-size: 13px;
  cursor: pointer;
}

.buy-sell-page__historyMoreBtn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .buy-sell-page__historyHead {
    display: none;
  }

  .buy-sell-page__historyRow {
    grid-template-columns: 1fr 1fr;
    gap: 6px 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/BuySellPage/buySellPage.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,SAAS;EACT,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE;IACE,QAAQ;IACR,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,QAAQ;IACR,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,iBAAiB;EACnB;;EAEA;IACE,SAAO;IACP,aAAa;IACb,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,uBAAuB;IACvB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;IACR,UAAU;IACV,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,QAAQ;EACR,aAAa;EACb,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA,8BAA8B;AAC9B;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;EAC3C,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;EAGE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kFAA6E;EAC7E,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kFAAuE;AACzE;;AAEA;EACE,mFAA+E;EAC/E,WAAW;EACX,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,mFAAyE;AAC3E;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf;;0BAEwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB;;;;mBAIiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB;;iCAE+B;EAC/B,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA,8GAA8G;AAC9G;EACE,eAAe;EACf,QAAQ;EACR,yBAAyB;EACzB,8BAA8B;EAC9B,aAAa;EACb,kCAA0B;UAA1B,0BAA0B;EAC1B,qBAAqB;EACrB,uBAAuB;EACvB,UAAU;EACV,0CAA0C;AAC5C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,+BAA+B;EAC/B,uCAAuC;EACvC,4BAA4B;EAC5B,kCAA0B;UAA1B,0BAA0B;EAC1B,4CAA4C;EAC5C,4DAA4D;EAC5D,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,iEAAiE;AACnE;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,+BAA+B;EAC/B,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;;EAEE;;;;IAIE,0BAA0B;EAC5B;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,aAAa;EACb,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,yCAAyC;EACzC,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;GAEG;;AAEH;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;EACxC,gBAAgB;EAChB,qCAAqC;EACrC,0BAA0B;EAC1B,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,+DAA+D;AACjE;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;;GAGG;;AAEH;EACE,oBAAoB;EACpB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;GAEG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB;;iCAE+B;EAC/B,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,aAAa;EACb,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;EAC/B,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,qBAAqB;EACrB,qCAAqC;EACrC,gBAAgB;EAChB,mBAAmB;EACnB;;iCAE+B;EAC/B,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,kDAAkD;AAClD;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA,eAAe;AACf;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,cAAc;EACd,8EAAuN;EACvN,YAAY;AACd;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,2BAA2B;;AAE3B;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,UAAU;EACV,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;;;AAIA;;;;EAIE,qBAAqB;AACvB;;AAEA,6FAA6F;AAC7F;EACE,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,iCAAiC;EACjC,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,+CAA+C;EAC/C,uDAAuD;AACzD;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,mCAAmC;EACnC,wCAAwC;EACxC,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,qBAAqB;EACrB,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;EAEE;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;;EAGA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,cAAc;IACd,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;IAC1B,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA,sDAAsD;AACtD;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAgCE,cAAc;AAChB;;AAEA;;;;;;;;;;;EAWE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;;;;;;;;;EAUE,mBAAmB;EACnB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;;EAEE,qBAAqB;EACrB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;;;;;;EAME,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;;;;;EAME,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;;;;;;;EAkBE,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,SAAS;EACT,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,sDAAsD;EACtD,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB;;+BAE6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;;EAEE;;IAEE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,SAAS;AACX;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;EAEE,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,kEAAkE;EAClE,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,8BAA8B;IAC9B,aAAa;EACf;AACF","sourcesContent":[".buy-sell-page {\n  width: 100%;\n  min-height: 100vh;\n  background: #14151a;\n  color: #ffffff;\n  padding: 40px 16px 40px;\n  box-sizing: border-box;\n}\n\nbody.light_theme .buy-sell-page {\n  background: #f8f9fa;\n  color: #121317;\n}\n\n.buy-sell-page__container {\n  max-width: 1180px;\n  margin: 0 auto;\n}\n\n.buy-sell-page__header {\n  margin-bottom: 24px;\n}\n\n.buy-sell-page__pageTitle {\n  margin: 0 0 6px;\n  font-size: 32px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: #ffffff;\n}\n\nbody.light_theme .buy-sell-page__pageTitle {\n  color: #121317;\n}\n\n.buy-sell-page__subtitle {\n  margin: 0;\n  font-size: 14px;\n  color: #848e9c;\n  line-height: 1.45;\n}\n\nbody.light_theme .buy-sell-page__subtitle {\n  color: #707a8a;\n}\n\n.buy-sell-page__titleHighlight {\n  color: #d1aa67;\n}\n\n.buy-sell-page__mainGrid {\n  display: grid;\n  grid-template-columns: 1.15fr 1fr;\n  gap: 36px;\n  align-items: stretch;\n  margin-bottom: 32px;\n}\n\n@media (min-width: 992px) {\n  .buy-sell-page__card--hot {\n    order: 1;\n    height: 100%;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .buy-sell-page__card--trade {\n    order: 2;\n    height: 100%;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n  }\n\n  .buy-sell-page__stepper {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    padding-bottom: 0;\n  }\n\n  .buy-sell-page__step {\n    flex: 1;\n    display: flex;\n    align-items: flex-start;\n    gap: 18px;\n  }\n\n  .buy-sell-page__stepIconWrap {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    align-self: stretch;\n    height: 100%;\n  }\n\n  .buy-sell-page__stepLine {\n    flex: 1 1 auto !important;\n    height: auto !important;\n    min-height: 148px;\n  }\n}\n\n@media (max-width: 991px) {\n  .buy-sell-page__mainGrid {\n    grid-template-columns: 1fr;\n    display: flex;\n    flex-direction: column;\n    gap: 32px;\n  }\n\n  .buy-sell-page__card--trade {\n    order: 1;\n  }\n\n  .buy-sell-page__card--hot {\n    order: 2;\n    padding: 0;\n    background: transparent;\n    border: none;\n    box-shadow: none;\n  }\n\n  .buy-sell-page__stepper {\n    display: flex;\n    flex-direction: column;\n    gap: 0px;\n  }\n\n  .buy-sell-page__step {\n    display: flex;\n    align-items: stretch;\n    gap: 16px;\n  }\n\n  .buy-sell-page__stepIconWrap {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    align-self: stretch;\n  }\n\n  .buy-sell-page__featureCard {\n    padding: 14px 16px;\n    margin-top: 8px;\n  }\n}\n\n.buy-sell-page__card {\n  width: 100%;\n}\n\n.buy-sell-page__card--hot {\n  padding: 0;\n  overflow: visible;\n  display: flex;\n  flex-direction: column;\n}\n\n.buy-sell-page__card--hot .buy-sell-page__pageTitle {\n  margin: 0 0 10px;\n  font-size: 36px;\n  font-weight: 600;\n  letter-spacing: 0;\n  color: #ffffff;\n}\n\nbody.light_theme .buy-sell-page__card--hot .buy-sell-page__pageTitle {\n  color: #121317;\n}\n\n.buy-sell-page__card--hot .buy-sell-page__subtitle {\n  margin: 0 0 20px;\n  font-size: 17px;\n  font-weight: 400;\n  color: #848e9c;\n  line-height: 1.45;\n}\n\nbody.light_theme .buy-sell-page__card--hot .buy-sell-page__subtitle {\n  color: #707a8a;\n}\n\n/* Dynamic Asset Badges Bar */\n.buy-sell-page__badgeBar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 24px;\n  padding-bottom: 32px;\n  border-bottom: 1px solid #232730;\n  /* height: 56px; */\n  box-sizing: border-box;\n}\n\nbody.light_theme .buy-sell-page__badgeBar {\n  border-bottom-color: #dfe0e2;\n}\n\n.buy-sell-page__badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 14px;\n  background: transparent;\n  border: 1px solid #2b3139;\n  border-radius: 999px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #ebebeb;\n}\n\nbody.light_theme .buy-sell-page__badge {\n  background: #f8f9fa;\n  border-color: #dfe0e2;\n  color: #262933;\n}\n\n.buy-sell-page__badgeIcon {\n  font-size: 15px;\n  color: #848e9c;\n}\n\n/* 3-Step Vertical Stepper */\n.buy-sell-page__stepper {\n  display: flex;\n  flex-direction: column;\n  padding-left: 2px;\n  margin-top: 24px;\n  padding-bottom: 0;\n}\n\n.buy-sell-page__step {\n  display: flex;\n  align-items: flex-start;\n  gap: 18px;\n}\n\n.buy-sell-page__stepIconWrap {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n}\n\n.buy-sell-page__stepDiamond {\n  width: 32px;\n  height: 32px;\n  background: #363b47;\n  border-radius: 4px;\n  transform: rotate(45deg);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  z-index: 2;\n}\n\nbody.light_theme .buy-sell-page__stepDiamond {\n  background: #dfe0e2;\n}\n\n.buy-sell-page__stepDiamond span {\n  transform: rotate(-45deg);\n  font-size: 15px;\n  font-weight: 600;\n  color: #ffffff;\n  line-height: 1;\n}\n\nbody.light_theme .buy-sell-page__stepDiamond span {\n  color: #121317;\n}\n\n.buy-sell-page__stepLine {\n  width: 0;\n  height: 132px;\n  border-left: 2px dashed #363b47;\n  margin: 6px 0;\n}\n\nbody.light_theme .buy-sell-page__stepLine {\n  border-left-color: #dfe0e2;\n}\n\n.buy-sell-page__stepContent {\n  flex: 1 1 auto;\n  min-width: 0;\n  padding-top: 2px;\n  padding-bottom: 20px;\n}\n\n.buy-sell-page__step:last-child .buy-sell-page__stepContent {\n  padding-bottom: 0;\n}\n\n.buy-sell-page__stepTitle {\n  margin: 0 0 6px;\n  font-size: 20px;\n  font-weight: 600;\n  letter-spacing: 0;\n  color: #ffffff;\n}\n\nbody.light_theme .buy-sell-page__stepTitle {\n  color: #121317;\n}\n\n.buy-sell-page__stepDesc {\n  margin: 0;\n  font-size: 15px;\n  line-height: 1.5;\n  color: #848e9c;\n  width: 100%;\n}\n\n/* Trade Card (Right Column) */\n.buy-sell-page__card--trade {\n  background: #181a20;\n  border: 1px solid #2b2f36;\n  border-radius: 20px;\n  overflow: hidden;\n  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.35);\n  padding: 0 0 18px;\n}\n\nbody.light_theme .buy-sell-page__card--trade {\n  background: #ffffff;\n  border-color: #dfe0e2;\n  box-shadow: 0 8px 24px rgba(15, 18, 24, 0.08);\n}\n\n.buysell_mid_sl {\n  padding: 24px 24px 10px;\n}\n\n.buy-sell-page__tabs {\n  display: flex;\n  margin-bottom: 0px;\n  background: #202329;\n  height: 56px;\n  overflow: hidden;\n  isolation: isolate;\n  border-top-left-radius: 20px;\n  border-top-right-radius: 20px;\n}\n\nbody.light_theme .buy-sell-page__tabs {\n  background: #f2f3f4;\n}\n\nbody.light_theme .buy-sell-page__tab {\n  background: #f2f3f4;\n  color: #a0a3a7;\n}\n\nbody.light_theme .buy-sell-page__tab--active,\nbody.light_theme button.buy-sell-page__tab.buy-sell-page__tab--active,\nbody.light_theme button.buy-sell-page__tab.buybtn_lft.buy-sell-page__tab--active {\n  background: #ffffff;\n  background-color: #ffffff;\n}\n\n.buy-sell-page__tab {\n  flex: 1 1;\n  border: none;\n  background: #202329;\n  height: 56px;\n  padding: 0 20px;\n  font: inherit;\n  position: relative;\n  font-size: 18px;\n  font-weight: 700;\n  color: #848e9c;\n  border-radius: 0px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\nbutton.buy-sell-page__tab.buybtn_lft {\n  border-radius: 0px;\n  position: relative;\n}\n\nbutton.buy-sell-page__tab::before {\n  position: absolute;\n  top: 0;\n  bottom: -1px;\n  left: -7px;\n  content: \"\";\n  width: 42px;\n  height: auto;\n  background: url(\"./buy-sell_before_light.svg\") no-repeat left top / 100% 100%;\n  pointer-events: none;\n  z-index: 2;\n}\n\nbody.light_theme button.buy-sell-page__tab::before {\n  background: url(\"./buy-sell_before.svg\") no-repeat left top / 100% 100%;\n}\n\nbutton.buy-sell-page__tab.buybtn_lft::before {\n  background: url(\"./buy-sell_before2_light.svg\") no-repeat right top / 100% 100%;\n  right: -3px;\n  left: auto;\n  z-index: 2;\n}\n\nbody.light_theme button.buy-sell-page__tab.buybtn_lft::before {\n  background: url(\"./buy-sell_before2.svg\") no-repeat right top / 100% 100%;\n}\n\nbutton.buy-sell-page__tab.buy-sell-page__tab--active::before {\n  display: none;\n}\n\n.buy-sell-page__tab--active {\n  z-index: 1;\n  background: #181a20;\n  color: #e45561 !important;\n}\n\nbody.light_theme .buy-sell-page__tab--active {\n  background: #fff;\n  color: #e45561 !important;\n}\n\nbutton.buy-sell-page__tab.buybtn_lft.buy-sell-page__tab--active {\n  background: #181a20;\n}\n\nbody.light_theme button.buy-sell-page__tab.buybtn_lft.buy-sell-page__tab--active {\n  background: #fff;\n}\n\n.buy-sell-page__field {\n  margin-bottom: 16px;\n  border: 1px solid #2b3139;\n  background: transparent;\n  padding: 16px 20px;\n  border-radius: 16px;\n  position: relative;\n  transition: border-color 0.2s ease;\n}\n\nbody.light_theme .buy-sell-page__field {\n  background: #f8f9fa;\n  border-color: #dfe0e2;\n}\n\n.buy-sell-page__field:focus-within {\n  border-color: #f0b90b;\n}\n\n.buy-sell-page__field--spendFiat {\n  z-index: 1;\n}\n\n.buy-sell-page__field--spendFiatOpen {\n  z-index: 20;\n}\n\n.buy-sell-page__field--receivePicker {\n  z-index: 1;\n}\n\n.buy-sell-page__field--receivePickerOpen {\n  z-index: 20;\n}\n\n.buy-sell-page__field--sellCrypto {\n  z-index: 1;\n}\n\n.buy-sell-page__field--sellCryptoOpen {\n  z-index: 20;\n}\n\n.buy-sell-page__fieldLbl {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: #848e9c;\n  margin-bottom: 8px;\n}\n\nbody.light_theme .buy-sell-page__fieldLbl {\n  color: #848e9c;\n}\n\n.buy-sell-page__fieldRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.buy-sell-page__input {\n  flex: 1 1;\n  min-width: 0;\n  border: none;\n  background: transparent;\n  font: inherit;\n  font-size: 22px;\n  font-weight: 700;\n  color: #ffffff;\n  padding: 0;\n}\n\nbody.light_theme .buy-sell-page__input {\n  color: #121317;\n}\n\n.buy-sell-page__field.is-mirrored .buy-sell-page__input {\n  opacity: 0.88;\n}\n\n.buy-sell-page__input::placeholder {\n  color: #646a78;\n}\n\n.buy-sell-page__input:focus {\n  outline: none;\n}\n\n.buy-sell-page__assetPill {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  padding: 6px 14px 6px 8px;\n  cursor: pointer;\n  font-size: 15px;\n  font-weight: 700;\n}\n\nbutton.buy-sell-page__assetPill--btn {\n  border: 1px solid #2e323d;\n  background: #252831;\n  color: #ffffff;\n  padding: 6px 14px 6px 8px;\n  margin: 0;\n  border-radius: 20px;\n  cursor: pointer;\n  transition:\n    background 0.2s ease,\n    border-color 0.2s ease;\n}\n\nbody.light_theme button.buy-sell-page__assetPill--btn {\n  background: #ffffff;\n  border-color: #dfe0e2;\n  color: #121317;\n}\n\nbutton.buy-sell-page__assetPill--btn:hover {\n  background: #2e323e;\n}\n\nbody.light_theme button.buy-sell-page__assetPill--btn:hover {\n  background: #f2f3f4;\n}\n\nbutton.buy-sell-page__assetPill--btn:focus-visible {\n  outline: 2px solid #262933;\n  outline-offset: 2px;\n  border-radius: 8px;\n}\n\n.buy-sell-page__pillIcon {\n  width: 22px;\n  height: 22px;\n  object-fit: contain;\n}\n\n.buy-sell-page__cryptoPillIcon {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  object-fit: contain;\n  flex-shrink: 0;\n  background: #f4faf6;\n  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.06);\n}\n\n.buy-sell-page__cryptoPillIcon--lg {\n  width: 36px;\n  height: 36px;\n}\n\n.buy-sell-page__flagInr {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: linear-gradient(180deg,\n      #ff9933 0%,\n      #ffffff 45%,\n      #138808 45%,\n      #138808 100%);\n  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.08);\n}\n\n.buy-sell-page__flagInr--lg {\n  width: 30px;\n  height: 30px;\n}\n\n.buy-sell-page__fiatCircle {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.08);\n}\n\n.buy-sell-page__fiatCircle--lg {\n  width: 30px;\n  height: 30px;\n}\n\n.buy-sell-page__fiatCircleText {\n  font-size: 7px;\n  font-weight: 700;\n  color: #fff;\n  line-height: 1.05;\n  letter-spacing: -0.02em;\n  text-align: center;\n  padding: 0 2px;\n}\n\n.buy-sell-page__fiatCircle--lg .buy-sell-page__fiatCircleText {\n  font-size: 10px;\n}\n\n.buy-sell-page__fiatDropdown {\n  position: absolute;\n  left: 0px;\n  right: 0px;\n  top: calc(100% + 4px);\n  background: #fff;\n  border-radius: 12px;\n  box-shadow:\n    0 10px 28px rgba(0, 0, 0, 0.12),\n    0 0 0 1px rgba(0, 0, 0, 0.06);\n  padding: 10px 0 8px;\n  max-height: 300px;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Mobile: currency/asset pickers render in a portal (card has overflow:hidden and clips absolute dropdowns) */\n.buy-sell-page__currencyPickerOverlay {\n  position: fixed;\n  inset: 0;\n  z-index: 9999999999999999;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  backdrop-filter: blur(4px);\n  align-items: flex-end;\n  justify-content: center;\n  padding: 0;\n  animation: bsp-fade-in 160ms ease-out both;\n}\n\nbody.light_theme .buy-sell-page__currencyPickerOverlay {\n  background: rgb(255 255 255 / 20%);\n}\n\n.buy-sell-page__currencyPickerSheet {\n  width: 100%;\n  max-height: min(88vh, 780px);\n  background: rgb(26 26 26 / 20%);\n  border: 1px solid rgb(255 255 255 / 5%);\n  border-radius: 18px 18px 0 0;\n  backdrop-filter: blur(4px);\n  box-shadow: 0 -10px 40px rgba(0, 0, 0, 0.18);\n  padding: 8px 0 calc(12px + env(safe-area-inset-bottom, 0px));\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  animation: bsp-sheet-up 220ms cubic-bezier(0.2, 0.8, 0.2, 1) both;\n}\n\nbody.light_theme .buy-sell-page__currencyPickerSheet {\n  background: #fff;\n}\n\n.buy-sell-page__currencyPickerOverlay .buy-sell-page__fiatDropdown--sheet {\n  background: none !important;\n  border: none !important;\n}\n\n.buy-sell-page__currencyPickerHandle {\n  width: 44px;\n  height: 5px;\n  border-radius: 999px;\n  background: rgba(0, 0, 0, 0.12);\n  margin: 4px auto 10px;\n  flex-shrink: 0;\n}\n\n@keyframes bsp-fade-in {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes bsp-sheet-up {\n  from {\n    transform: translateY(18px);\n  }\n\n  to {\n    transform: translateY(0);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n\n  .buy-sell-page__currencyPickerOverlay,\n  .buy-sell-page__currencyPickerSheet,\n  .buy-sell-page__payOverlay,\n  .buy-sell-page__payDialog {\n    animation: none !important;\n  }\n}\n\n.buy-sell-page__fiatDropdown--sheet {\n  position: relative;\n  left: auto;\n  right: auto;\n  top: auto;\n  box-shadow: none;\n  max-height: none;\n  flex: 1 1 auto;\n  min-height: 0;\n  padding: 6px 0 4px;\n  border-radius: 0;\n}\n\n.buy-sell-page__fiatDropdown--sheet .buy-sell-page__fiatList {\n  max-height: min(52vh, 520px);\n}\n\n.buy-sell-page__fiatSearch {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 12px 8px;\n  padding: 10px 12px;\n  background: #f1f2f4;\n  border-radius: 10px;\n}\n\n.buy-sell-page__fiatSearchIcon {\n  font-size: 18px;\n  color: #8e9299;\n  flex-shrink: 0;\n}\n\n.buy-sell-page__fiatSearchInput {\n  border: none;\n  background: transparent;\n  flex: 1 1;\n  min-width: 0;\n  font: inherit;\n  font-size: 14px;\n  color: #262933;\n  outline: none;\n}\n\n.buy-sell-page__fiatSearchInput::placeholder {\n  color: #a0a3a7;\n}\n\n.buy-sell-page__fiatList {\n  list-style: none;\n  margin: 0;\n  padding: 0 8px 4px;\n  overflow-y: auto;\n  max-height: 232px;\n}\n\n.buy-sell-page__fiatOption {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 10px 10px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  border-radius: 10px;\n  text-align: left;\n  font: inherit;\n  color: inherit;\n}\n\n.buy-sell-page__fiatOption:hover {\n  background: #f2f3f4;\n}\n\n.buy-sell-page__fiatOption:focus-visible {\n  outline: 2px solid #262933;\n  outline-offset: -2px;\n}\n\n.buy-sell-page__fiatOptionMeta {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.buy-sell-page__fiatOptionCode {\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.buy-sell-page__fiatOptionName {\n  font-size: 12px;\n  font-weight: 500;\n  color: #8e9299;\n}\n\n.buy-sell-page__fiatEmpty {\n  margin: 0;\n  padding: 16px 12px;\n  font-size: 14px;\n  color: #8e9299;\n  text-align: center;\n  list-style: none;\n}\n\n.buy-sell-page__pillCode {\n  letter-spacing: 0.02em;\n}\n\n.buy-sell-page__pillCaret {\n  font-size: 18px;\n  color: var(--bsp-muted);\n  transition: transform 0.2s ease;\n}\n\n.buy-sell-page__pillCaret--open {\n  transform: rotate(180deg);\n}\n\n.buy-sell-page__paySelect {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 0px;\n  border: none;\n  /* border-radius: var(--bsp-radius-sm); */\n  background: none;\n  font: inherit;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n  text-align: left;\n}\n\n.pay_with_container {\n  margin-top: 50px;\n}\n\n/* .buy-sell-page__paySelect:hover {\n  border-color: #d1d5db;\n} */\n\n.buy-sell-page__payIcon {\n  width: 24px;\n  height: 24px;\n  object-fit: contain;\n}\n\n.buy-sell-page__payLabel {\n  flex: 1;\n}\n\n/* Payment method modal */\n.buy-sell-page__payOverlay {\n  position: fixed;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  -webkit-tap-highlight-color: transparent;\n  z-index: 9999999;\n  background-color: rgb(10 10 10 / 20%);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  animation: bsp-fade-in 160ms ease-out both;\n}\n\nbody.light_theme .buy-sell-page__payOverlay {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n.buy-sell-page__payDialog {\n  width: min(720px, 100%);\n  max-height: min(86vh, 760px);\n  background: #fff;\n  border-radius: 18px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  animation: bsp-pop-in 180ms cubic-bezier(0.2, 0.8, 0.2, 1) both;\n}\n\n@keyframes bsp-pop-in {\n  from {\n    opacity: 0;\n    transform: translateY(8px) scale(0.98);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.buy-sell-page__payHead {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px 10px;\n}\n\n.buy-sell-page__payTitle {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 700;\n  color: #f3f3f3;\n}\n\nbody.light_theme .buy-sell-page__payTitle {\n  color: #111827;\n}\n\nspan.buy-sell-page__payRowCcy {\n  color: #c4c4c4;\n}\n\nbody.light_theme span.buy-sell-page__payRowCcy {\n  color: #111827;\n}\n\n.buy-sell-page__payClose {\n  border: none;\n  background: transparent;\n  font-size: 28px;\n  line-height: 1;\n  cursor: pointer;\n  color: #9aa0a6;\n  padding: 6px 10px;\n  border-radius: 10px;\n}\n\n/* .buy-sell-page__payClose:hover {\n  background: #f3f4f6;\n  color: #111827;\n} */\n\n.buy-sell-page__payBody {\n  padding: 0 24px 10px;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.buy-sell-page__paySection {\n  padding: 10px 0 4px;\n}\n\n.buy-sell-page__paySectionHead {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 14px;\n  color: #9aa0a6;\n  padding: 8px 0 10px;\n}\n\n.buy-sell-page__payList {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.buy-sell-page__payRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  width: 100%;\n  padding: 16px 16px;\n  border-radius: 14px;\n  border: 1px solid #e5e7eb;\n  background: #fff;\n  cursor: pointer;\n  text-align: left;\n}\n\n.buy-sell-page__payRow:hover {\n  border-color: #cbd5e1;\n}\n\n.buy-sell-page__payRow--selected {\n  border-color: #111827;\n}\n\n.buy-sell-page__payRow--disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.buy-sell-page__payRowLeft {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  min-width: 0;\n  flex: 1 1;\n}\n\n.buy-sell-page__payRowIconWrap {\n  width: 26px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.buy-sell-page__payRowIcon {\n  width: 26px;\n  height: 26px;\n  object-fit: contain;\n}\n\n.buy-sell-page__payRowMeta {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.buy-sell-page__payRowLabel {\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.buy-sell-page__payRowSub {\n  font-size: 13px;\n  color: #9aa0a6;\n  font-weight: 500;\n  line-height: 1.35;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 430px;\n}\n\n.buy-sell-page__payRowRight {\n  font-size: 15px;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\nspan.buy-sell-page__paySectionLeft {\n  font-size: 16px;\n  font-weight: 600;\n}\n\nspan.buy-sell-page__paySectionRight {\n  font-weight: 600;\n}\n\n/* .buy-sell-page__payRowCcy {\n  font-weight: 800;\n} */\n\n.buy-sell-page__payFoot {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 16px 20px 20px;\n  border-top: 1px solid #eef0f2;\n}\n\n.buy-sell-page__payFootAmt {\n  font-size: 22px;\n  font-weight: 700;\n}\n\n.buy-sell-page__payFootHint {\n  font-size: 14px;\n  color: #9aa0a6;\n  font-weight: 700;\n  margin-top: 2px;\n}\n\n.buy-sell-page__payConfirm {\n  padding: 14px 22px;\n  border-radius: 999px;\n  border: none;\n  background: #303236;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.buy-sell-page__payConfirm:hover {\n  filter: brightness(1.06);\n}\n\n.buy-sell-page__payConfirm:disabled {\n  background: #eef0f2;\n  color: #b8bdc6;\n  cursor: not-allowed;\n  filter: none;\n}\n\n.buy-sell-page__payClose:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.buy-sell-page__bankDialog {\n  width: min(760px, 100%);\n}\n\n.buy-sell-page__bankForm {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  padding-bottom: 6px;\n}\n\n.buy-sell-page__bankLbl {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #313131;\n}\n\n.buy-sell-page__bankInput {\n  width: 100%;\n  border: none;\n  background: #f3f4f6;\n  border-radius: 12px;\n  padding: 14px 14px;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  color: #111827;\n  outline: none;\n  box-sizing: border-box;\n}\n\n.buy-sell-page__bankInput::placeholder {\n  color: #9aa0a6;\n  font-weight: 600;\n}\n\n.buy-sell-page__bankSelect {\n  width: 100%;\n  border: none;\n  background: #f3f4f6;\n  border-radius: 12px;\n  padding: 14px 14px;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  color: #9aa0a6;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n}\n\n.buy-sell-page__bankSelectText {\n  color: #9aa0a6;\n}\n\n.buy-sell-page__bankCaret--open {\n  transform: rotate(180deg);\n  display: inline-block;\n}\n\n.buy-sell-page__bankDropdown {\n  margin-top: 10px;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow:\n    0 10px 28px rgba(0, 0, 0, 0.12),\n    0 0 0 1px rgba(0, 0, 0, 0.06);\n  padding: 10px 0 8px;\n  max-height: 320px;\n  display: flex;\n  flex-direction: column;\n}\n\n.buy-sell-page__bankSearch {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 12px 10px;\n  padding: 10px 12px;\n  background: #f1f2f4;\n  border-radius: 10px;\n}\n\n.buy-sell-page__bankSearchIcon {\n  font-size: 18px;\n  color: #8e9299;\n  flex-shrink: 0;\n}\n\n.buy-sell-page__bankSearchInput {\n  border: none;\n  background: transparent;\n  flex: 1 1;\n  min-width: 0;\n  font: inherit;\n  font-size: 14px;\n  color: #262933;\n  outline: none;\n}\n\n.buy-sell-page__bankSearchInput::placeholder {\n  color: #a0a3a7;\n}\n\n.buy-sell-page__bankList {\n  list-style: none;\n  margin: 0;\n  padding: 0 8px 4px;\n  overflow-y: auto;\n  max-height: 248px;\n}\n\n.buy-sell-page__bankOption {\n  width: 100%;\n  border: none;\n  background: transparent;\n  text-align: left;\n  padding: 10px 12px;\n  border-radius: 10px;\n  font: inherit;\n  font-size: 15px;\n  font-weight: 500;\n  color: #111827;\n  cursor: pointer;\n}\n\n.buy-sell-page__bankOption:hover {\n  background: #f4f5f7;\n}\n\n.buy-sell-page__bankEmpty {\n  margin: 0;\n  padding: 16px 12px;\n  font-size: 14px;\n  color: #8e9299;\n  text-align: center;\n  list-style: none;\n}\n\n.buy-sell-page__bankPhoneRow {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  position: relative;\n  border: none;\n  border-radius: 12px;\n  padding: 10px;\n  background: #f3f4f5;\n}\n\n.buy-sell-page__bankPhoneCode {\n  border: none;\n  background: none;\n  border-right: 1px solid #e4e4e4;\n  /* border-radius: 10px; */\n  height: 30px;\n  padding: 0 10px;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 700;\n  color: #6a7282;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.buy-sell-page__countryFlag {\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  line-height: 1;\n}\n\n.buy-sell-page__bankPhoneCodeText {\n  min-width: 40px;\n  text-align: left;\n}\n\n.buy-sell-page__bankInput--phone {\n  flex: 1 1;\n  border: none;\n  background: transparent;\n  padding: 0;\n}\n\n.buy-sell-page__phoneDropdown {\n  position: absolute;\n  left: 0;\n  top: calc(100% + 8px);\n  width: min(520px, calc(100vw - 64px));\n  background: #fff;\n  border-radius: 12px;\n  box-shadow:\n    0 10px 28px rgba(0, 0, 0, 0.12),\n    0 0 0 1px rgba(0, 0, 0, 0.06);\n  padding: 10px 0 8px;\n  z-index: 5;\n}\n\n.buy-sell-page__phoneOption {\n  width: 100%;\n  border: none;\n  background: transparent;\n  text-align: left;\n  padding: 12px 12px;\n  border-radius: 10px;\n  font: inherit;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.buy-sell-page__phoneOption:hover {\n  background: #f4f5f7;\n}\n\n.buy-sell-page__phoneOptionMeta {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.buy-sell-page__phoneOptionCode {\n  font-size: 15px;\n  font-weight: 800;\n  color: #111827;\n}\n\n.buy-sell-page__phoneOptionName {\n  font-size: 12px;\n  font-weight: 600;\n  color: #8e9299;\n}\n\n.buy-sell-page__estimate {\n  margin: 36px 0 18px;\n  font-size: 14px;\n  color: #84888c;\n  font-weight: 700;\n}\n\n/* Highlight only the rate line “1 USDT = … INR” */\n.buy-sell-page__estimateRate {\n  color: #f1f1f1;\n}\n\nbody.light_theme .buy-sell-page__estimateRate {\n  color: #000;\n}\n\n.buy-sell-page__estimateRate--sell {\n  color: var(--bsp-text);\n  font-weight: 700;\n}\n\n.buy-sell-page__cta {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 52px;\n  padding: 0 20px;\n  text-align: center;\n  font-size: 16px;\n  font-weight: 700;\n  color: #ebebeb;\n  background: #2b2f36;\n  border-radius: 14px;\n  text-decoration: none;\n  border: none;\n  cursor: pointer;\n  box-sizing: border-box;\n  transition: all 0.2s ease;\n}\n\n.buy-sell-page__cta:not(:disabled) {\n  background: #d1aa67;\n  color: #ffffff;\n}\n\n.buy-sell-page__cta:not(:disabled):hover {\n  background: #c59f5e;\n  color: #ffffff;\n}\n\n.buy-sell-page__cta:disabled {\n  background: #2b2f36;\n  color: #848e9c;\n  cursor: not-allowed;\n  filter: none;\n}\n\n/* How to buy */\n.buy-sell-page__how {\n  margin: 100px 0px;\n}\n\n.buy-sell-page__sectionTitle {\n  margin: 0 0 28px;\n  font-size: 38px;\n  font-weight: 700;\n}\n\n.buy-sell-page__howRow {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px 4px;\n  padding-top: 24px;\n}\n\n.buy-sell-page__howStep {\n  flex: 1 1 140px;\n  max-width: 220px;\n  text-align: center;\n  padding: 12px 8px;\n}\n\n.buy-sell-page__howIconWrap {\n  width: 110px;\n  /* height: 56px; */\n  margin: 0 auto 10px;\n  /* border-radius: 14px; */\n  /* background: #f3f4f6; */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.buy-sell-page__howIcon {\n  font-size: 26px;\n  color: var(--bsp-text);\n}\n\n.buy-sell-page__howStepTitle {\n  display: block;\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 1.35;\n  margin-bottom: 6px;\n}\n\n.buy-sell-page__howStepDesc {\n  display: block;\n  font-size: 12px;\n  color: var(--bsp-muted);\n  line-height: 1.45;\n}\n\n.buy-sell-page__howArrow {\n  align-self: center;\n  width: 20px;\n  height: 20px;\n  margin: 0 4px;\n  flex-shrink: 0;\n  background: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23707a8a' stroke-width='2'%3E%3Cpath d='M9 6l6 6-6 6'/%3E%3C/svg%3E\") center / contain no-repeat;\n  opacity: 0.7;\n}\n\n@media (max-width: 767px) {\n  .buy-sell-page__howArrow {\n    display: none;\n  }\n}\n\n/* Quick steps + visual */\n.buy-sell-page__quick {\n  display: grid;\n  grid-template-columns: 1fr 1.5fr;\n  gap: 32px;\n  align-items: center;\n  padding: 40px 0px;\n}\n\n@media (max-width: 991px) {}\n\n.buy-sell-page__quickVisual {\n  display: flex;\n  max-width: 430px;\n  justify-content: center;\n  align-items: center;\n}\n\n.buy-sell-page__quickImg {\n  max-width: 100%;\n  width: min(360px, 100%);\n  height: auto;\n  object-fit: contain;\n}\n\n.buy-sell-page__quickTitle {\n  margin: 0 0 22px;\n  font-size: 38px;\n  font-weight: 700;\n  line-height: 1.25;\n}\n\n.buy-sell-page__quickList {\n  list-style: none;\n  margin: 0;\n  display: flex;\n  position: relative;\n  padding: 0;\n  flex-direction: column;\n  gap: 40px;\n  margin-top: 40px;\n}\n\n.buy-sell-page__quickList:before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 11px;\n  width: 1px;\n  height: 88%;\n  background: #232326;\n}\n\nbody.light_theme .buy-sell-page__quickList:before {\n  background: #101828;\n}\n\n.buy-sell-page__quickItem {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.buy-sell-page__quickItem:last-child {\n  margin-bottom: 0;\n}\n\n@media (max-width: 991px) {\n  .buy-sell-page__quickItem {\n    text-align: left;\n  }\n}\n\n.buy-sell-page__quickNum {\n  flex-shrink: 0;\n  width: 24px;\n  position: relative;\n  height: 24px;\n  border-radius: 50%;\n  background: #ffffff12;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 700;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\nbody.light_theme .buy-sell-page__quickNum {\n  background: #101828;\n}\n\n.buy-sell-page__quickItemTitle {\n  display: block;\n  font-size: 18px;\n  font-weight: 700;\n  margin-bottom: 6px;\n}\n\n.buy-sell-page__quickItemText {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.55;\n  color: #84888c;\n}\n\n\n\nbody:not(.light_theme) .buy-sell-page__historyTable,\nbody:not(.light_theme) .buy-sell-page__historyChip,\nbody:not(.light_theme) .buy-sell-page__historyRow,\nbody:not(.light_theme) .buy-sell-page__historyMoreBtn {\n  border-color: #2b3139;\n}\n\n/* Redesign styles for Subtitle, Feature Sub-Cards, Hints Grid, Quote Summary & Footer Note */\n.buy-sell-page__subtitle {\n  margin: -10px 0 16px;\n  font-size: 14px;\n  line-height: 1.45;\n  color: #848e9c;\n  font-weight: 500;\n}\n\nbody.light_theme .buy-sell-page__subtitle {\n  color: #707a8a;\n}\n\n.buy-sell-page__featureCard {\n\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 12px 15px;\n  width: 100%;\n  box-sizing: border-box;\n  background: rgb(255 255 255 / 5%);\n  /* border: 1px solid #2b3139; */\n  border-radius: 10px;\n  margin-top: 10px;\n  /* box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2); */\n  transition: border-color 0.2s ease, transform 0.2s ease;\n}\n\n.buy-sell-page__featureCard:hover {\n  border-color: #3b404e;\n  transform: translateY(-1px);\n}\n\nbody.light_theme .buy-sell-page__featureCard {\n  background: #efefef;\n  border-color: #dfe0e2;\n}\n\nbody.light_theme .buy-sell-page__featureCard:hover {\n  border-color: #dfe0e2;\n}\n\n.buy-sell-page__featureIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border-radius: 8px;\n  font-size: 16px;\n  flex-shrink: 0;\n}\n\n.buy-sell-page__featureIcon--gold {\n  background: rgba(240, 185, 11, 0.15);\n  color: #f0b90b;\n}\n\n.buy-sell-page__featureIcon--blue {\n  background: rgba(30, 144, 255, 0.15);\n  color: #3b82f6;\n}\n\n.buy-sell-page__featureIcon--green {\n  background: rgba(1, 188, 141, 0.15);\n  color: #01bc8d;\n}\n\n.buy-sell-page__featureMeta {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.buy-sell-page__featureTitle {\n  font-size: 16px;\n  font-weight: 400;\n  color: #ffffffe5;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\nbody.light_theme .buy-sell-page__featureTitle {\n  color: #121317;\n}\n\n.buy-sell-page__featureDesc {\n  margin: 0;\n  font-size: 14px;\n  color: #848e9c;\n  line-height: 1.4;\n}\n\n.buy-sell-page__liveBadgeTag {\n  display: inline-flex;\n  align-items: center;\n  padding: 1px 5px;\n  background: rgba(1, 188, 141, 0.15);\n  border: 1px solid rgba(1, 188, 141, 0.3);\n  color: #01bc8d;\n  font-size: 9.5px;\n  font-weight: 700;\n  border-radius: 4px;\n  letter-spacing: 0.04em;\n  margin-left: 4px;\n  vertical-align: middle;\n}\n\n.buy-sell-page__hintsGrid {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 10px;\n  margin: 10px 0 12px;\n  padding: 10px 14px;\n  background: transparent;\n  border: 1px solid #2b3139;\n  border-radius: 12px;\n}\n\nbody.light_theme .buy-sell-page__hintsGrid {\n  background: #f8f9fa;\n  border-color: #dfe0e2;\n}\n\n.buy-sell-page__hintsCol {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.buy-sell-page__hintsCol--right {\n  align-items: flex-end;\n  text-align: right;\n}\n\n.buy-sell-page__hintIcon {\n  font-size: 13px;\n  color: #848e9c;\n  vertical-align: -1px;\n}\n\n.buy-sell-page__liveStatus {\n  margin: 0;\n  font-size: 11.5px;\n  color: #848e9c;\n  display: flex;\n  align-items: center;\n}\n\n.buy-sell-page__liveDot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #01bc8d;\n  box-shadow: 0 0 6px #01bc8d;\n  display: inline-block;\n  margin-right: 5px;\n  animation: bsp-dot-pulse 2s infinite;\n}\n\n@keyframes bsp-dot-pulse {\n  0% {\n    opacity: 1;\n    transform: scale(1);\n  }\n\n  50% {\n    opacity: 0.4;\n    transform: scale(0.85);\n  }\n\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.buy-sell-page__liveTxt {\n  color: #01bc8d;\n  font-weight: 700;\n}\n\n.buy-sell-page__quoteTimer {\n  margin: 0;\n  font-size: 11.5px;\n  color: #848e9c;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.buy-sell-page__refreshBtn {\n  cursor: pointer;\n  color: #f0b90b;\n  transition: transform 0.3s ease;\n}\n\n.buy-sell-page__refreshBtn:hover {\n  transform: rotate(180deg);\n}\n\n.buy-sell-page__autoRefreshText {\n  font-size: 10.5px;\n  color: #5e6673;\n}\n\n.buy-sell-page__quoteSummaryTitle {\n  font-size: 13px;\n  font-weight: 700;\n  color: #ffffff;\n  margin-bottom: 2px;\n}\n\nbody.light_theme .buy-sell-page__quoteSummaryTitle {\n  color: #121317;\n}\n\n.buy-sell-page__quoteRow {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 12.5px;\n}\n\n.buy-sell-page__quoteRow span {\n  color: #848e9c;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.buy-sell-page__infoIcon {\n  font-size: 13px;\n  color: #5e6673;\n  cursor: help;\n}\n\n.buy-sell-page__quoteDivider {\n  height: 0;\n  border-top: 1px dashed #2b2f36;\n  margin: 3px 0;\n}\n\nbody.light_theme .buy-sell-page__quoteDivider {\n  border-top-color: #dfe0e2;\n}\n\n.buy-sell-page__greenVal {\n  color: #01bc8d !important;\n  font-weight: 700 !important;\n}\n\n.buy-sell-page__quoteNotice {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 2px;\n  padding-top: 6px;\n  border-top: 1px solid #1e2026;\n  font-size: 11.5px;\n  color: #848e9c;\n}\n\nbody.light_theme .buy-sell-page__quoteNotice {\n  border-top-color: #eef0f2;\n}\n\n.buy-sell-page__shieldIcon {\n  color: #01bc8d;\n  font-size: 13px;\n}\n\n.buy-sell-page__quoteRow strong {\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\nbody.light_theme .buy-sell-page__cta:disabled {\n  background: #eaecef;\n  color: #a0a3a7;\n}\n\n.buy-sell-page__footerGuarantee {\n  margin: 10px 0 0;\n  text-align: center;\n  font-size: 11.5px;\n  color: #848e9c;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n}\n\n.buy-sell-page__footerGuarantee i {\n  color: #01bc8d;\n  font-size: 13px;\n}\n\n@media (max-width: 1440px) {\n  .buy-sell-page__pageTitle {\n    font-size: 36px;\n  }\n\n  .buy-sell-page__sectionTitle {\n    font-size: 32px;\n  }\n\n  .buy-sell-page__quickTitle {\n    font-size: 32px;\n  }\n}\n\n@media (max-width: 1366px) {\n  .buy-sell-page__mainGrid {\n    gap: 50px;\n  }\n}\n\n@media (max-width: 1200px) {\n\n  .buy-sell-page__card--hot .buy-sell-page__pageTitle {\n    font-size: 32px;\n  }\n\n  .buy-sell-page__tab {\n    padding: 13px 16px;\n    font-size: 18px;\n  }\n\n  .buy-sell-page__how {\n    margin: 60px 0px;\n  }\n\n  .buy-sell-page__sectionTitle {\n    font-size: 28px;\n  }\n\n  .buy-sell-page__cta {\n    padding: 12px 20px;\n    font-size: 14px;\n  }\n\n  .buy-sell-page__quickTitle {\n    font-size: 28px;\n  }\n\n  .buy-sell-page__howStepTitle {\n    font-size: 18px;\n  }\n\n  button.buy-sell-page__tab::before {\n    top: 0px;\n  }\n}\n\n@media (max-width: 991px) {\n  .buy-sell-page {\n    padding: 55px 24px 64px;\n  }\n\n  .buy-sell-page__card--hot .buy-sell-page__pageTitle {\n    font-size: 24px;\n  }\n\n  .buy-sell-page__card--hot .buy-sell-page__subtitle {\n    font-size: 15px;\n  }\n\n  .buy-sell-page__sectionTitle {\n    font-size: 22px;\n  }\n\n  .buy-sell-page__quickTitle {\n    font-size: 22px;\n    text-align: left;\n  }\n\n  .convert-page__sectionTitle {\n    font-size: 24px;\n  }\n}\n\n@media (max-width: 767px) {\n\n  .buy-sell-page {\n    padding: 30px 20px 30px;\n  }\n\n  .buy-sell-page__cta {\n    padding: 10px 20px;\n    font-size: 13px;\n    height: auto;\n    border-radius: 8px;\n  }\n\n  .buy-sell-page__card--hot .buy-sell-page__pageTitle {\n    font-size: 22px;\n  }\n\n  .buy-sell-page__stepTitle {\n    font-size: 17px;\n  }\n\n  .buy-sell-page__stepDesc {\n    font-size: 13px;\n  }\n\n  .buy-sell-page__featureTitle {\n    font-size: 14px;\n  }\n\n  .buy-sell-page__featureDesc {\n    font-size: 12px;\n  }\n\n  .buy-sell-page__badgeBar {\n    margin-bottom: 5px;\n    padding-bottom: 24px;\n  }\n\n  .buy-sell-page__stepDiamond span {\n    font-size: 13px;\n  }\n\n  .df-deposit-history-section .container {\n    padding: 0px;\n  }\n\n\n  .buy-sell-page__pageTitle {\n    font-size: 22px;\n    margin-bottom: 15px;\n  }\n\n  .buy-sell-page__mainGrid {\n    flex-direction: column;\n    display: flex;\n  }\n\n  .buy-sell-page__container .mobile_view {\n    display: block;\n    font-size: 22px;\n    padding: 0px 0px 5px;\n  }\n\n  .buysell_mid_sl {\n    padding: 20px 18px 10px;\n  }\n\n  .buy-sell-page__payOverlay {\n    align-items: end;\n  }\n\n  .buy-sell-page__payDialog {\n    border-radius: 18px 18px 0px 0px;\n  }\n\n  .buy-sell-page__field {\n    padding: 14px;\n  }\n\n  .pay_with_container {\n    margin-top: 0px;\n  }\n\n  .buy-sell-page__input {\n    font-size: 15px;\n  }\n\n  .buy-sell-page__fieldLbl {\n    font-size: 13px;\n  }\n\n  .buy-sell-page__mainGrid {\n    gap: 30px;\n  }\n\n  .buy-sell-page__paySelect {\n    font-size: 15px;\n  }\n\n  .buy-sell-page__hotChart {\n    display: none;\n  }\n\n  .buy-sell-page__how {\n    margin: 30px 0px;\n  }\n\n  .buy-sell-page__sectionTitle {\n    font-size: 20px;\n    margin-bottom: 15px;\n  }\n\n  .buy-sell-page__howStepTitle {\n    font-size: 15px;\n  }\n\n  .buy-sell-page__howIconWrap {\n    width: 60px;\n  }\n\n  .buy-sell-page__quickVisual {\n    display: none;\n  }\n\n  .buy-sell-page__quickCopy {\n    width: 100%;\n  }\n\n  .buy-sell-page__quick {\n    grid-template-columns: 1fr;\n    padding: 20px 0px;\n  }\n\n  .buy-sell-page__quickTitle {\n    font-size: 20px;\n  }\n\n  .convert-page__assetsSection {\n    padding: 30px 20px 30px;\n  }\n\n  .buy-sell-page .convert-page__assetsSection {\n    padding: 30px 0px 30px;\n  }\n\n  .convert-page__sectionTitle {\n    font-size: 20px;\n  }\n\n  .buy-sell-page__payConfirm {\n    padding: 12px 40px;\n  }\n}\n\n@media (max-width: 580px) {\n  .buy-sell-page__quickList:before {\n    height: 84%;\n  }\n}\n\n/* fix kero - Dark theme support for Buy Crypto page */\nhtml[data-theme=\"dark\"] .buy-sell-page,\nbody:not(.light_theme) .buy-sell-page {\n  background: #181a20;\n  color: #ffffff;\n}\n\nhtml[data-theme=\"dark\"] .buy-sell-page__pageTitle,\nhtml[data-theme=\"dark\"] .buy-sell-page__hotTitle,\nhtml[data-theme=\"dark\"] .buy-sell-page__hotPrice,\nhtml[data-theme=\"dark\"] .buy-sell-page__sectionTitle,\nhtml[data-theme=\"dark\"] .buy-sell-page__quickTitle,\nhtml[data-theme=\"dark\"] .buy-sell-page__howStepTitle,\nhtml[data-theme=\"dark\"] .buy-sell-page__input,\nhtml[data-theme=\"dark\"] .buy-sell-page__selector,\nhtml[data-theme=\"dark\"] .buy-sell-page__paySelect,\nhtml[data-theme=\"dark\"] .buy-sell-page__payName,\nhtml[data-theme=\"dark\"] .buy-sell-page__payDialogTitle,\nhtml[data-theme=\"dark\"] .convert-page__assetName,\nhtml[data-theme=\"dark\"] .buy-sell-page__hotPair,\nhtml[data-theme=\"dark\"] .buy-sell-page__quickInfo,\nhtml[data-theme=\"dark\"] .buy-sell-page__quickList,\nhtml[data-theme=\"dark\"] .buy-sell-page__promoText,\nbody:not(.light_theme) .buy-sell-page__pageTitle,\nbody:not(.light_theme) .buy-sell-page__hotTitle,\nbody:not(.light_theme) .buy-sell-page__hotPrice,\nbody:not(.light_theme) .buy-sell-page__sectionTitle,\nbody:not(.light_theme) .buy-sell-page__quickTitle,\nbody:not(.light_theme) .buy-sell-page__howStepTitle,\nbody:not(.light_theme) .buy-sell-page__input,\nbody:not(.light_theme) .buy-sell-page__selector,\nbody:not(.light_theme) .buy-sell-page__paySelect,\nbody:not(.light_theme) .buy-sell-page__payName,\nbody:not(.light_theme) .buy-sell-page__payDialogTitle,\nbody:not(.light_theme) .convert-page__assetName,\nbody:not(.light_theme) .buy-sell-page__hotPair,\nbody:not(.light_theme) .buy-sell-page__quickInfo,\nbody:not(.light_theme) .buy-sell-page__quickList,\nbody:not(.light_theme) .buy-sell-page__promoText {\n  color: #ffffff;\n}\n\nhtml[data-theme=\"dark\"] .buy-sell-page__howStepDesc,\nhtml[data-theme=\"dark\"] .buy-sell-page__quickDesc,\nhtml[data-theme=\"dark\"] .convert-page__assetSymbol,\nhtml[data-theme=\"dark\"] .buy-sell-page__payEstimate,\nhtml[data-theme=\"dark\"] .buy-sell-page__tab,\nbody:not(.light_theme) .buy-sell-page__howStepDesc,\nbody:not(.light_theme) .buy-sell-page__quickDesc,\nbody:not(.light_theme) .convert-page__assetSymbol,\nbody:not(.light_theme) .buy-sell-page__payEstimate,\nhtml[data-theme=\"dark\"] .buy-sell-page__tab,\nbody:not(.light_theme) .buy-sell-page__tab {\n  color: #a0aab5;\n  background: #202329;\n}\n\nhtml[data-theme=\"dark\"] .buy-sell-page__tabWrap,\nbody:not(.light_theme) .buy-sell-page__tabWrap {\n  background: #2b3139;\n}\n\nhtml[data-theme=\"dark\"] .buy-sell-page__tab--active,\nbody:not(.light_theme) .buy-sell-page__tab--active {\n  background: #181a20;\n}\n\nhtml[data-theme=\"dark\"] .buy-sell-page__card--buySell,\nhtml[data-theme=\"dark\"] .buy-sell-page__quickInfo,\nhtml[data-theme=\"dark\"] .buy-sell-page__hotTableWrap,\nhtml[data-theme=\"dark\"] .buy-sell-page__promoBanner,\nhtml[data-theme=\"dark\"] .buy-sell-page__card--trade,\nbody:not(.light_theme) .buy-sell-page__card--buySell,\nbody:not(.light_theme) .buy-sell-page__quickInfo,\nbody:not(.light_theme) .buy-sell-page__hotTableWrap,\nbody:not(.light_theme) .buy-sell-page__promoBanner,\nbody:not(.light_theme) .buy-sell-page__card--trade {\n  background: #181a20;\n  border-color: #2b3139;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);\n}\n\nhtml[data-theme=\"dark\"] .buy-sell-page__payDialog,\nbody:not(.light_theme) .buy-sell-page__payDialog {\n  background: #181a20a3;\n  border-color: #2b3139;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);\n}\n\nhtml[data-theme=\"dark\"] .buy-sell-page__field,\nhtml[data-theme=\"dark\"] .buy-sell-page__quoteMeta,\nhtml[data-theme=\"dark\"] .buy-sell-page__paySelect,\nbody:not(.light_theme) .buy-sell-page__field,\nbody:not(.light_theme) .buy-sell-page__quoteMeta,\nbody:not(.light_theme) .buy-sell-page__paySelect {\n  background: transparent;\n  border-color: #2b3139;\n}\n\nhtml[data-theme=\"dark\"] .buy-sell-page__field:focus-within,\nbody:not(.light_theme) .buy-sell-page__field:focus-within {\n  border-color: #d3b06c;\n}\n\nhtml[data-theme=\"dark\"] .buy-sell-page__payOption:hover,\nbody:not(.light_theme) .buy-sell-page__payOption:hover {\n  background: #2b3139;\n}\n\nhtml[data-theme=\"dark\"] .buy-sell-page__hotTable tr,\nbody:not(.light_theme) .buy-sell-page__hotTable tr {\n  border-bottom: 1px solid #2b3139;\n}\n\nhtml[data-theme=\"dark\"] .buy-sell-page__hotTable tr:last-child,\nbody:not(.light_theme) .buy-sell-page__hotTable tr:last-child {\n  border-bottom: none;\n}\n\nhtml[data-theme=\"dark\"] .buy-sell-page__fiatDropdown,\nhtml[data-theme=\"dark\"] .buy-sell-page__bankDropdown,\nhtml[data-theme=\"dark\"] .buy-sell-page__payRow,\nbody:not(.light_theme) .buy-sell-page__fiatDropdown,\nbody:not(.light_theme) .buy-sell-page__bankDropdown,\nbody:not(.light_theme) .buy-sell-page__payRow {\n  background: #181a20;\n  border-color: #2b3139;\n}\n\nhtml[data-theme=\"dark\"] .buy-sell-page__fiatSearch,\nhtml[data-theme=\"dark\"] .buy-sell-page__bankSearch,\nbody:not(.light_theme) .buy-sell-page__fiatSearch,\nbody:not(.light_theme) .buy-sell-page__bankSearch {\n  background: #0d1219;\n}\n\nhtml[data-theme=\"dark\"] .buy-sell-page__fiatSearchInput,\nhtml[data-theme=\"dark\"] .buy-sell-page__bankSearchInput,\nhtml[data-theme=\"dark\"] .buy-sell-page__payRowLabel,\nhtml[data-theme=\"dark\"] .buy-sell-page__payRowPrice,\nhtml[data-theme=\"dark\"] .buy-sell-page__payFootAmt,\nhtml[data-theme=\"dark\"] .buy-sell-page__fiatOptionCode,\nhtml[data-theme=\"dark\"] .buy-sell-page__bankOption,\nhtml[data-theme=\"dark\"] .buy-sell-page__fiatEmpty,\nhtml[data-theme=\"dark\"] .buy-sell-page__bankEmpty,\nbody:not(.light_theme) .buy-sell-page__fiatSearchInput,\nbody:not(.light_theme) .buy-sell-page__bankSearchInput,\nbody:not(.light_theme) .buy-sell-page__payRowLabel,\nbody:not(.light_theme) .buy-sell-page__payRowPrice,\nbody:not(.light_theme) .buy-sell-page__payFootAmt,\nbody:not(.light_theme) .buy-sell-page__fiatOptionCode,\nbody:not(.light_theme) .buy-sell-page__bankOption,\nbody:not(.light_theme) .buy-sell-page__fiatEmpty,\nbody:not(.light_theme) .buy-sell-page__bankEmpty {\n  color: #ffffff;\n}\n\nhtml[data-theme=\"dark\"] .buy-sell-page__paySectionLeft,\nhtml[data-theme=\"dark\"] .buy-sell-page__paySectionRight,\nbody:not(.light_theme) .buy-sell-page__paySectionLeft,\nbody:not(.light_theme) .buy-sell-page__paySectionRight {\n  color: #a0aab5;\n}\n\nhtml[data-theme=\"dark\"] .buy-sell-page__fiatOption:hover,\nhtml[data-theme=\"dark\"] .buy-sell-page__bankOption:hover,\nbody:not(.light_theme) .buy-sell-page__fiatOption:hover,\nbody:not(.light_theme) .buy-sell-page__bankOption:hover {\n  background: #2b3139;\n}\n\nhtml[data-theme=\"dark\"] .buy-sell-page__payRow:hover,\nhtml[data-theme=\"dark\"] .buy-sell-page__payRow--selected,\nbody:not(.light_theme) .buy-sell-page__payRow:hover,\nbody:not(.light_theme) .buy-sell-page__payRow--selected {\n  border-color: #d3b06c;\n}\n\nhtml[data-theme=\"dark\"] .buy-sell-page__payFoot,\nbody:not(.light_theme) .buy-sell-page__payFoot {\n  border-top-color: #2b3139;\n}\n\nbody.light_theme .buy-sell-page__payFoot {\n  border-top-color: #eaecef;\n}\n\n.buy-sell-page__infoPanel {\n  padding: 18px 24px;\n  border: 1px solid #dfe0e2;\n  border-radius: 16px;\n}\n\n.buy-sell-page__infoList {\n  margin: 12px 0 0;\n  padding-left: 18px;\n  color: #707a8a;\n  font-size: 14px;\n  line-height: 1.55;\n}\n\n.buy-sell-page__infoList li+li {\n  margin-top: 8px;\n}\n\n.buy-sell-page__hints {\n  display: grid;\n  gap: 4px;\n  margin: 0 0 12px;\n  min-height: 2.8em;\n}\n\n.buy-sell-page__balanceHint,\n.buy-sell-page__limitHint {\n  margin: 0;\n  font-size: 13px;\n  color: #848e9c;\n  min-height: 1.2em;\n  line-height: 1.35;\n}\n\n.buy-sell-page__balanceHint--placeholder,\n.buy-sell-page__limitHint--placeholder {\n  opacity: 0.72;\n}\n\n.buy-sell-page__balanceHint--error {\n  color: #e45561;\n  font-weight: 600;\n}\n\n/* Fixed quote breakdown — dark outlined sub-card */\n.buy-sell-page__quoteMeta {\n  display: grid;\n  grid-template-rows: repeat(5, minmax(22px, auto)) auto;\n  gap: 10px;\n  margin: 0 0 20px;\n  padding: 16px 20px;\n  border: 1px solid #2b3139;\n  border-radius: 16px;\n  min-height: 180px;\n  background: transparent;\n  box-sizing: border-box;\n  transition:\n    border-color 160ms ease,\n    background-color 160ms ease;\n}\n\nbody.light_theme .buy-sell-page__quoteMeta {\n  background: #f8f9fa;\n  border-color: #dfe0e2;\n}\n\n.buy-sell-page__quoteMeta>div {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 12px;\n  font-size: 13.5px;\n  min-height: 22px;\n}\n\n.buy-sell-page__quoteMeta span {\n  color: #848e9c;\n  font-weight: 500;\n  flex-shrink: 0;\n}\n\n.buy-sell-page__quoteMeta strong {\n  font-weight: 600;\n  color: #ffffff;\n  text-align: right;\n  word-break: break-word;\n}\n\nbody.light_theme .buy-sell-page__quoteMeta strong {\n  color: #121317;\n}\n\n.buy-sell-page__quoteMeta.is-empty strong {\n  font-weight: 500;\n  color: #848e9c;\n}\n\n.buy-sell-page__quoteMeta.is-loading strong {\n  animation: bsp-quote-pulse 1.1s ease-in-out infinite;\n}\n\n@keyframes bsp-quote-pulse {\n\n  0%,\n  100% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0.45;\n  }\n}\n\n.buy-sell-page__countdown {\n  margin: 8px 0 0;\n  padding-top: 10px;\n  border-top: 1px solid #232730;\n  font-size: 13px;\n  font-weight: 600;\n  color: #f0b90b;\n  text-align: center;\n  min-height: 1.25em;\n}\n\nbody.light_theme .buy-sell-page__countdown {\n  border-top-color: #dfe0e2;\n}\n\n.buy-sell-page__countdown.is-refreshing {\n  color: #e45561;\n}\n\n.buy-sell-page__quoteError {\n  margin: 0 0 12px;\n  font-size: 13px;\n  color: #e45561;\n}\n\n.buy-sell-page__quoteList {\n  display: grid;\n  gap: 12px;\n  margin: 0;\n}\n\n.buy-sell-page__quoteList dt {\n  margin: 0 0 4px;\n  font-size: 12px;\n  color: #848e9c;\n}\n\n.buy-sell-page__quoteList dd {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\nbody.light_theme .buy-sell-page__quoteList dd {\n  color: #121317;\n}\n\n.buy-sell-page__quoteHint {\n  margin: 16px 0 0;\n  font-size: 13.3px;\n  line-height: 1.45;\n  color: #848e9c;\n}\n\n.buy-sell-page__history {\n  margin: 8px 0 48px;\n}\n\n.buy-sell-page__historyTop {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n}\n\n.buy-sell-page__historyFilters {\n  display: flex;\n  gap: 8px;\n}\n\n.buy-sell-page__historyChip {\n  border: 1px solid #dfe0e2;\n  background: transparent;\n  color: inherit;\n  border-radius: 999px;\n  padding: 6px 14px;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.buy-sell-page__historyChip.is-active {\n  background: #303236;\n  border-color: #303236;\n  color: #fff;\n}\n\n.buy-sell-page__historyStatus,\n.buy-sell-page__historyEmpty {\n  margin: 0;\n  padding: 16px 4px;\n  font-size: 14px;\n  color: #848e9c;\n}\n\n.buy-sell-page__historyTable {\n  border: 1px solid #dfe0e2;\n  border-radius: 16px;\n  overflow: hidden;\n}\n\n.buy-sell-page__historyHead,\n.buy-sell-page__historyRow {\n  display: grid;\n  grid-template-columns: 1.3fr 0.7fr 1.1fr 1.1fr 0.9fr 0.85fr 0.75fr;\n  gap: 8px;\n  padding: 12px 16px;\n  align-items: center;\n}\n\n.buy-sell-page__historyHead {\n  font-size: 13px;\n  color: #848e9c;\n}\n\n.buy-sell-page__historyRow {\n  border-top: 1px solid #dfe0e2;\n  font-size: 13px;\n}\n\n.buy-sell-page__historyCell {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.buy-sell-page__historyRepeat {\n  color: #c9a227;\n  font-weight: 600;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.buy-sell-page__historyRepeat:hover {\n  text-decoration: underline;\n}\n\n.buy-sell-page__historyReview {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 32px;\n  padding: 4px 14px;\n  border-radius: 999px;\n  border: 1px solid #d1aa67;\n  background: transparent;\n  color: #d1aa67;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.buy-sell-page__historyReview:hover {\n  background: rgba(209, 170, 103, 0.12);\n}\n\n.buy-sell-page__historyCopy {\n  margin-left: 8px;\n  border: 0;\n  background: transparent;\n  color: #d1aa67;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.buy-sell-page__historyBadge {\n  display: inline-flex;\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.buy-sell-page__historyBadge.is-success {\n  color: #01bc8d;\n  background: rgba(1, 188, 141, 0.12);\n}\n\n.buy-sell-page__historyBadge.is-pending {\n  color: #c9a227;\n  background: rgba(201, 162, 39, 0.12);\n}\n\n.buy-sell-page__historyBadge.is-danger {\n  color: #e45561;\n  background: rgba(228, 85, 97, 0.12);\n}\n\n.buy-sell-page__historyBadge.is-neutral {\n  color: #848e9c;\n  background: rgba(132, 142, 156, 0.12);\n}\n\n.buy-sell-page__historyMore {\n  display: flex;\n  justify-content: center;\n  padding: 16px 0 0;\n}\n\n.buy-sell-page__historyMoreBtn {\n  border: 1px solid #dfe0e2;\n  background: transparent;\n  color: inherit;\n  border-radius: 999px;\n  padding: 8px 18px;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.buy-sell-page__historyMoreBtn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n@media (max-width: 768px) {\n  .buy-sell-page__historyHead {\n    display: none;\n  }\n\n  .buy-sell-page__historyRow {\n    grid-template-columns: 1fr 1fr;\n    gap: 6px 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
